<div class='messageBottomFixed' *ngIf="timeSlotEnd!=''">
    <div class='messageCenter'>
        {{timeSlotEnd}}
    </div>
</div>

<div class="messageBottomFixed" [class.messageBottomFixed1]="showDivOnPage(timeSlotEnd,governmentIDMessage) && showGovernmentMessage" *ngIf="showDivOnPage(timeSlotEnd,cartMessageError) ">
    <div class='messageCenter'>
        {{cartMessageError}}
    </div>
</div>

<div class="messageBottomFixed" *ngIf="showDivOnPage(timeSlotEnd,governmentIDMessage) && showGovernmentMessage ">
    <div class='messageCenter'>
        {{governmentIDMessage}}
        <span *ngIf="governmentIDStatus==='0' || governmentIDStatus==='3'"><a style='color:#fff' routerLink="/upload-id">Click Here</a></span>
    </div>
</div>

<div id="mySidenav" class="sidenav" [ngStyle]="getSideNavColor()">
    <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">
        <i class="fa fa-close"></i>
    </a>

    <div *ngIf="auth" id="username_onmob" style="display:none !important;" class="right-head-username">
        <span style="top: 15px;color: aliceblue;font-size: 16px;position: absolute;left: 10px;"> Hi, &nbsp;<a (click)="hideSidenav_user()" routerLink="/dashboard/profile" style="color: #fff">{{userName | firstword |titlecase}}</a> </span>
    </div>
    <div style="padding: 10px 15px; margin-bottom: 0px;text-align: center;">
        <img class="sideImg" src="{{siteDada?.footerLogo?.url}}" width="100">

    </div>

    <ul class="sideMenu-tiles">
        <li [ngStyle]="{'background': item?.bgColor}" *ngFor="let item of sideMenu">
            <a *ngIf="item?.url !='store' && item?.show" onclick="closeNav()" (click)="routeToUrls(item?.url, item)" routerLinkActive="active" class="cursor" [routerLinkActiveOptions]="{ exact: true }" id="isShop">
                <img *ngIf="item?.logo" src="{{item?.logo}}">
                <span [ngStyle]="{'color': item?.textColor}">{{item?.title}}</span>
            </a>

            <a *ngIf="item?.url =='store' && item?.show" (click)="openMapModal()" routerLinkActive="active" class="cursor" [routerLinkActiveOptions]="{ exact: true }" id="isShop">
                <img *ngIf="item?.logo" src="{{item?.logo}}">
                <span [ngStyle]="{'color': item?.textColor}">{{item?.title}}</span>
            </a>
        </li>

    </ul>



    <div class="right-slide-bar-bottom">
        <div class="row">
            <div class="col-12">
                <a href="javascript:;" onclick="closeNav()" (click)="openRegister()" *ngIf="!auth" class="signup" style="background: #fff;">create account</a>
            </div>

            <!-- SIGN IN -->
            <div class="col-12">
                <a href="javascript:;" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="openLogin()" class="signin" onclick="closeNav()" *ngIf="!auth" style="background: #9ac07f;">Sign In</a>
            </div>


            <div class="col-12">
                <a href="javascript:;" routerLink="/dashboard/profile" onclick="closeNav()" *ngIf="auth" class='signin' style="background: #d4a7bb;">MY ACCOUNT</a>
            </div>
            <div class="col-12">
                <a href="javascript:;" onclick="closeNav()" (click)="openLogoutPopUp()" *ngIf="auth" class='signup' style="background: #dc6868;">log out</a>
            </div>

        </div>
    </div>
    <div (click)="openStoreTimeModal3()">
        <p class="slide-menu-store-timing" [ngStyle]="getTextIconColor({'background-color':siteDada?.headerTextColor},'HOURS')">
            STORE HOURS <br>
        </p>
    </div>

    <div id="mySidenav" class="right-head-username">

        <p style="font-size: 15px;text-align: center; position: fixed;width: 350px;bottom: 10px; margin-bottom: 10px;" class="footer-copyright" [ngStyle]="getTextIconColor({'color':siteDada?.headerTextColor},'Powered')">Powered by &nbsp;
            <a href="https://www.cannalogic.com/" target="_blank">
                <img src="assets/images/cannalogic.png" alt="" class="cannalogic-logo"></a>
        </p>
    </div>
</div>

<div class="modal shopping-cart modalBackgroundNone" id="shoppingCart" style="background: rgba(0,0,0,0.7);">
    <div class="modal-dialog cart_in_mobile">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" *ngIf="!showTimeSlotDiv && !showPlaceOrderDiv && !guestModeOn"><i class="fa fa-shopping-cart" style="padding-right: 6px;"></i>Cart Summary</h4>

                <button *ngIf="!canShowThankyoupage" type="button" class="close" id="close-cart" data-dismiss="modal"><i class="fa fa-close"></i>
                </button>
                <button type="button" *ngIf="canShowThankyoupage" (click)="closeCart()" class="close" id="close-cart" data-dismiss="modal"><i class="fa fa-close"></i>
                </button>

            </div>
            <div class="modal-header" *ngIf="canShowThankyoupage" style="padding: 18px">
                <h4 class="modal-title check_text">{{thankyoupageType}}</h4>
            </div>
            <div class="modal-progress-bar">

                <h3 class="check_text_new" *ngIf="step!=1" style="font-weight: bold; margin: 10px 0px 28px 14px;">Checkout</h3>

                <div class="stepper-wrapper">
                    <div class="stepper-item completed" >
                        <div class="step-counter" style="background-color: #4bb543;"></div>
                        <div class="step-name">Summary</div>
                    </div>
                    <div class="stepper-item completed">
                        <div class="step-counter" [ngStyle]="step !=1 && {'background-color': '#4bb543'}"> </div>
                        <div class="step-name">Checkout</div>
                    </div>

                    <div class="stepper-item active">
                        <div class="step-counter" [ngStyle]="step ==5 && showPlaceOrderDiv&&  {'background-color': '#4bb543'}"></div>
                        <div class="step-name">Confirmation</div>
                    </div>
                </div>

              

                <div class="row">
                    <div class="col-md-6" *ngIf="CartBarLimitFlower > 0">
                        <div *ngIf="cartLength != 0 && auth && !showTimeSlotDiv && !showPlaceOrderDiv && !guestModeOn" class="progress-bar">
                            <div aria-valuemin="0" [ngStyle]="{ width: progressbarWidthFlower }" aria-valuemax="100" class="skill">{{ getDigitwithoutzero(weightLimitFlower) }}g</div>
                        </div>
                        <!-- For Guest -->
                        <div *ngIf="!auth && cartLength && !showTimeSlotDiv && !showPlaceOrderDiv && !guestModeOn" class="progress-bar">
                            <div aria-valuemin="0" [ngStyle]="{ width: progressbarWidthFlower }" aria-valuemax="100" class="skill">{{ getDigitwithoutzero(weightLimitFlower) }}g</div>
                        </div>
                        <div *ngIf="cartLength != 0 && !showTimeSlotDiv && !showPlaceOrderDiv && !guestModeOn && CartBarLimitFlower > 0" class="progress-bar1">
                            <span class="right">{{ CartBarLimitFlower }}g</span>
                            <img (click)="showToolTip1()" src="assets/images/tooltipQues.png" style="width: 18px; height: 18px; cursor: pointer; display: inline-block; margin-bottom: 7px" />
                            <span id="tooltip_new1" class="tooltiptext1">There is a maximun limit of {{ CartBarLimitFlower }}g Flower per order. Checkout will not be permitted if your order exceeds this limit</span>
                     
                        </div>
                    </div>

                    <div class="col-md-{{CartBarLimitFlower > 0  ? '6':'12'}}">

                        <div *ngIf="cartLength != 0 && auth && !showTimeSlotDiv && !showPlaceOrderDiv && !guestModeOn" class="progress-bar">
                            <div aria-valuemin="0" [ngStyle]="{ width: progressbarWidth }" aria-valuemax="100" class="skill">{{ getDigitwithoutzero(weightLimit) }}g</div>
                        </div>
                        <!-- For Guest -->
                        <div *ngIf="!auth && cartLength && !showTimeSlotDiv && !showPlaceOrderDiv && !guestModeOn" class="progress-bar">
                            <div aria-valuemin="0" [ngStyle]="{ width: guestProgressbarWidth }" aria-valuemax="100" class="skill">{{ getDigitwithoutzero(guestCartWeight) }}g</div>
                        </div>
                        <div *ngIf="cartLength != 0 && !showTimeSlotDiv && !showPlaceOrderDiv && !guestModeOn" class="progress-bar1">
                            <a *ngIf="!showTimeSlotDiv && !showPlaceOrderDiv && !guestModeOn && cartLength > 0" class="clear_cart" (click)="clearLogeedInusercart()" (keydown.enter)="clearLogeedInusercart()">Clear Cart</a>

                            <span class="right">{{ CartBarLimit }}g</span>
                            <img (click)="showToolTips()" src="assets/images/tooltipQues.png" style="width: 18px; height: 18px; cursor: pointer; display: inline-block; margin-bottom: 7px" />
                            <span id="tooltip_news" *ngIf="CartBarLimitFlower >0" class="tooltiptext1">There is a maximun limit of {{ CartBarLimit }}g Concentrates(Oils, Tincture, Edibles, Vapes, etc.) per order. Checkout will not be permitted if your order exceeds this limit</span>
                            <span id="tooltip_news" *ngIf="CartBarLimitFlower < 1" class="tooltiptext1">There is a maximun limit of {{ CartBarLimit }}g per order. Checkout will not be permitted if your order exceeds this limit</span>
                        </div>
                    </div>
                </div>

            </div>


            <div class="modal-body">

                <div *ngIf="step==1">
                    <div class="cart-products" *ngIf="!auth">
                        <div [class.padding-cart-message]="checkOutCartMessage!==''">
                            <p style='font-size: 18px;color:#ff0000;'>{{checkOutCartMessage}}</p>
                        </div>
                        <div *ngIf="cartLength===0 && !auth && !canShowThankyoupage">
                            <div style='text-align: center;margin-top: 5%;'>
                                <h6 class="empty_msg">No items in cart to display</h6>
                                <h4 class="light_msg">Hey, its feel so light</h4>
                                <img src="assets/images/cart.png" style='margin:auto; margin-bottom: 10px;' class="cartImage">
                                <p class="nothing_msg">There is nothing in your bag. Let's add some items.</p>
                            </div>
                        </div>
                        <div *ngIf="cartLength!==0">
                            <ul class="cartDivScrollable">
                                <ng-container *ngFor="let product of offlineCartProduct">
                                    <li>
                                        <div class="row align-items-center left-right-marg">
                                            <div class="col-2">
                                                <a (click)="redirectToDetailPage(product.productslug)">
                                                    <img class="image_shop" [src]='product.productImg'>
                                                </a>
                                            </div>
                                            <div class="col-4">
                                                <div class="product-name">{{product?.productName}}</div>
                                            </div>
                                            <div class="col-3">
                                                <div>
                                                    <div class='select-custom'>
                                                        <div *ngIf="product.quantity !==1" style="cursor:pointer;" class="value-button" id="decrease" value="Decrease Value" (click)="increaseDecreaseOfflineProduct(product.productId,product.optionId,product.optionTypeId,product.productType,product.quantity,false,product.weight,product?.myPrice)">
                                                            <img style="cursor:pointer;" src="assets/images/minus-black.png" alt="" style="width: 10px; height: auto; display: inline-block;">
                                                        </div>
                                                        <div style="cursor:pointer;" *ngIf="product.quantity ==1" class="value-button" id="delete" (click)="removeProductFromOfflineCart(product.productId,product)">
                                                            <span class="" style="font-size: 13px; color: #fff;">
                                                                <a class="delete-item-product">
                                                                    <img style="cursor:grab" src="assets/images/bin.png" alt="" style="width: 13px; height: auto; display: inline-block;">
                                                                </a>
                                                            </span>
                                                        </div>

                                                        <input type="text" id="qty" value="{{product?.quantity}}" class='form-control' disabled />
                                                        <div style="cursor:pointer;" class="value-button" id="increase" value="Increase Value" (click)="offlineWeightIncrease(product.productId,product.optionId,product.optionTypeId,product.productType,product.quantity,true,product.weight,product?.myPrice,product)">
                                                            <img style="cursor:grab" src="assets/images/add-black.png" alt="" style="width: 10px; height: auto; display: inline-block;">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-2">
                                                <div class="product-price1">
                                                    <div class="price">
                                                        <div *ngIf="product.productType==='bundle'">
                                                            <ng-container *ngFor='let bundleOption of product.bundleOption'>
                                                                <span>{{bundleOption.productName}} (1 Pack)</span>
                                                                <br>
                                                            </ng-container>
                                                        </div>
                                                        <span *ngIf="product.productType==='bundle'">{{product.productTitle}}</span>
                                                        <span class="newSpanSize" [class.margin-left-12]="product.productType==='simple'">{{product.price | currency:'USD'}}
                                                        </span>
                                                        <div *ngIf="product?.myPrice > product.price ">
                                                            <span class="discount-price">{{product.myPrice | currency:'USD'}}</span>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-1">
                                                <a (click)="removeProductFromOfflineCart(product.productId,product)" class="delete-item-product">
                                                    <i class="fa fa-close">
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                </ng-container>
                            </ul>

                            <div class="total-price " [class.text-align-right]='offineDiscountNumber!==0'>
                                <div class="order-total" [class.col-width]="offineDiscountNumber!==0" style="width: 100%; margin-top:3%">
                                    <div class="row">
                                        <div class="col-9" style="text-align: right;">
                                            <ul class="total-discount-bottom">
                                                <li><span style="font-weight:bold !important;">Subtotal </span></li>
                                                <li><span style="font-weight:bold !important;">Total </span></li>
                                            </ul>
                                        </div>
                                        <div class='col-3'>
                                            <ul class="total-discount-bottom">
                                                <li><span style="font-weight:bold !important;">{{getOffineCartAmount() | currency:'USD'}} </span></li>

                                                <li><span style="font-weight:bold !important;">{{(guest_subtotal) | currency:'USD' }} </span></li>
                                            </ul>
                                        </div>

                                    </div>
                                    <p style="font-size: 11px;">*Sales tax will be added at checkout.</p>
                                </div>
                            </div>

                            <div class="recommended-for-you" *ngIf="RECOMMNEDLIST?.length  && !showTimeSlotDiv ">
                                <h6>Staff Picks</h6>


                                <div class="list-of-product">
                                    <div class="row left-right-marg" style="margin: 0; width: 100%;">
                                        <div class="staff-list" style="width:100%">
                                            <ul class="staff-ul">
                                                <li class="col-6 staff-li" *ngFor="let data of RECOMMNEDLIST;let y = index;">
                                                    <div class="product product-11 text-center" (mouseleave)="setemptyHoverValue(y)" (mouseover)="setNewArrivalValue(y)" [ngStyle]="{'backgroundColor':getBackGroundColorAccToSpecies(data?.productDetails?.species)}">

                                                        <div class="product-details-action">
                                                            <a href="javascript:;">
                                                                <img src="assets/images/add1.png" (click)="addSelectedVariance(data)" alt="">
                                                            </a>
                                                        </div>
                                                        <figure class="product-media">
                                                            <div *ngIf="data?.productDetails?.species?.length">
                                                                <div class=" tag-name-indica" *ngIf="data?.productDetails?.species[0]['speciesName'] === 'INDICA'">
                                                                    I
                                                                </div>
                                                                <div class="tag-name-sativa" *ngIf="data?.productDetails?.species[0]['speciesName'] === 'SATIVA'">
                                                                    S
                                                                </div>
                                                                <div class="tag-name-hybrit" *ngIf="data?.productDetails?.species[0]['speciesName'] === 'HYBRID'">
                                                                    H
                                                                </div>


                                                                <div class='discount-price-text' *ngIf="findOfferPre(data) && !(data.myPrice > data.price)">
                                                                    <span class="image_descount_prist-list">{{findOfferPre(data)?.promoCodeDiscount}}% Off </span>
                                                                </div>
                                                            </div>
                                                            <a class="cursor" (click)="redirectToDetailPage(data.productslug)">
                                                                <img [src]="getImageSize3(data?.productDetails?.Assets)" alt="" class="product-image Staff_Picks_Img">
                                                            </a>
                                                            <div class="Sale_tag_parent">
                                                                <div class="Sale_new" *ngIf="data.myPrice>data.price">
                                                                    SALE
                                                                </div>
                                                            </div>
                                                          

                                                            <div class="thc-tag-new1">
                                                                <ng-container *ngFor="let compound of compoundList">
                                                                  <span 
                                                                    *ngIf="checkThc(getCompoundValue(compound.min, data?.productDetails), getCompoundValue(compound.max, data?.productDetails))" 
                                                                    class="thc-tag-new">
                                                                    {{ compound.label }}&nbsp;
                                                                    <span *ngIf="checkZero(getCompoundValue(compound.min, data?.productDetails))">
                                                                      {{ getCompoundValue(compound.min, data?.productDetails) }}{{ thcType(data?.productDetails?.ThcType) }}-
                                                                    </span>
                                                                    <span *ngIf="checkZero(getCompoundValue(compound.max, data?.productDetails))">
                                                                      {{ getCompoundValue(compound.max, data?.productDetails) }}{{ thcType(data?.productDetails?.ThcType) }}&nbsp;
                                                                    </span>
                                                                    <span *ngIf="checkZero(getCompoundValue(compound.sum, data?.productDetails))">&nbsp;({{getCompoundValue(compound.sum, data?.productDetails) }})&nbsp;</span>
                                                                  </span>
                                                                </ng-container>
                                                            </div>

                                                            <div id="{{data?.CatalogItemId}}" *ngIf="varianceArray?.length>0">
                                                                <div id='welcomeDiv' class="answer_list" [ngStyle]="{'display':(isShown && (actualId == data?.CatalogItemId) && showVariance)?'block':'none'}">
                                                                    <input type="button" name="answer" value="" style="background: url(assets/images/close.png);" (click)="showDiv1(data?.CatalogItemId)" class="hideproducttag">
                                                                    <h3>Select an option </h3>
                                                                    <div *ngFor="let data of varianceArray;let i= index;">
                                                                        <div class="tag">
                                                                            <div class="row" (click)="HandleVarinceAddToCartOrNot(data,1)" style="cursor: pointer;">
                                                                                <div class="col-4">
                                                                                    <p class="gram">
                                                                                        {{data?.productDetails?.NetWeight}}
                                                                                    </p>
                                                                                </div>
                                                                                <div class="col-8">
                                                                                    <p class="gram" *ngIf="this.VARID!= data?._id " style="text-align: right;">
                                                                                        ${{data?.price}}
                                                                                    </p>
                                                                                    <div *ngIf="!auth" class='increase-qty' [ngStyle]="{'display':(this.VARID  === data?._id )?'block':'none'}">
                                                                                        <a disabled="varqtyvalue <= 1">
                                                                                            <img style="cursor:grab" src="assets/images/minus-black.png" (click)="increaseDecreaseOfflineProductforvar(data.CatalogItemId,data.optionId,data.optionTypeId,'simple',1,false,data.productDetails.EquivalentToVal,data,data?.productDetails?.HeroShotUri,i)" alt="">
                                                                                        </a>
                                                                                        <input type="text" [(ngModel)]='varqtyvalue' id="qty" value="1" disabled class='form-control' />
                                                                                        <img style="cursor:grab" src="assets/images/add-black.png" alt="" (click)="increaseDecreaseOfflineProductforvar(data.CatalogItemId,data.optionId,data.optionTypeId,'simple',1,true,data.productDetails.EquivalentToVal,data,data?.productDetails?.HeroShotUri,i)">
                                                                                    </div>
                                                                                    <div *ngIf="auth" class='increase-qty' [ngStyle]="{'display':(this.VARID  === data?._id )?'block':'none'}">
                                                                                        <a disabled="varqtyvalue <= 1">
                                                                                            <img style="cursor:grab" src="assets/images/minus-black.png" (click)="addToCartvar(data,false)" alt="">
                                                                                        </a>
                                                                                        <input type="text" [(ngModel)]='varqtyvalue' id="qty" value="1" disabled class='form-control' />
                                                                                        <img style="cursor:grab" src="assets/images/add-black.png" alt="" (click)="addToCartvar(data,true)">
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </figure>
                                                        <div class="product-body product-body-staff">
                                                            <h5 class="brand-name-product">
                                                                {{data?.productDetails?.brand?.brandName?data?.productDetails?.brand?.brandName:"BrandName"}}
                                                            </h5>
                                                            <h3 class="product-title">
                                                                <a (click)="redirectToDetailPage(data.productslug)">
                                                                    {{data.productDetails?.ProductName}}</a>
                                                            </h3>
                                                            <div class="product-price">
                                                                <span *ngIf="data.myPrice > data.price" style="display: inline-block; font-size: 13px; color: #000; font-weight: 600; text-decoration: line-through">
                                                                     {{ data?.myPrice | currency:'USD'}}</span>&nbsp;
                                                                  <span style="font-size: 12px !important;; font-weight: 500;"  *ngIf="data.myPrice > data.price">Member’s Price </span>
                                                                   <span [ngClass]="findOfferPre(data) && !(data.myPrice > data.price) ? 'line-through':''">{{ data?.price | currency:'USD' }}</span>&nbsp; 
                                                                   <span style="font-size: 12px !important;; font-weight: 500;"  *ngIf="findOfferPre(data) && !(data.myPrice > data.price)">Member’s Price </span>
                                                                   <span *ngIf="findOfferPre(data) && !(data.myPrice > data.price)">{{reduceByPercentage(data.price,findOfferPre(data)?.promoCodeDiscount) | currency :'USD'}} </span>
                                                              </div>

                                                            <div class="row add-strang-item"  style="margin:0; padding: 0;" *ngIf="data?.productDetails?.tags?.length">
                                                                <div class="col-6" *ngFor="let tag of data.productDetails.tags | slice:0:4">
                                                                  <div class="add-strang-part1" *ngIf="tag?.tagName" [ngStyle]="{ background: getBackGroundColor(tag) }" [matTooltip]="tag.tagName">
                                                                    {{ tag.tagName }}
                                                                  </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div *ngIf="auth">
                                            <div class="staff-list" style="width:100%">
                                                <ul class="staff-ul">
                                                    <li class="col-6 staff-li" style="padding: 0;" *ngFor="let data of recommendedProductsList">
                                                        <div class="product product-11 text-center no_tag_type_gray ">
                                                            <div class="product-details-action">
                                                                <a href="javascript:;">
                                                                    <img src="assets/images/add1.png" (click)="addSelectedVariance(data)" alt="">
                                                                </a>
                                                            </div>
                                                            <figure class="product-media">
                                                                <div *ngIf="data?.productDetails?.species?.length">
                                                                    <div class=" tag-name-indica" *ngIf="data?.productDetails?.species[0]['speciesName'] === 'INDICA'">
                                                                        I
                                                                    </div>
                                                                    <div class="tag-name-sativa" *ngIf="data?.productDetails?.species[0]['speciesName'] === 'SATIVA'">
                                                                        S
                                                                    </div>
                                                                    <div class="tag-name-hybrit" *ngIf="data?.productDetails?.species[0]['speciesName'] === 'HYBRID'">
                                                                        H
                                                                    </div>
                                                                </div>
                                                                <a (click)="redirectToDetailPage(data.productslug)" class="cursor">
                                                                    <img [src]="getImageSize(data?.productDetails?.HeroShotUri?data?.productDetails?.HeroShotUri:defaultUrl)" alt="" class="product-image Staff_Picks_Img">
                                                                </a>
                                                                <div class="Sale_tag_parent">
                                                                    <div class="Sale_new" *ngIf="data.myPrice>data.price">
                                                                        SALE</div>
                                                                </div>

                                                               <div class="thc-tag-new1">
                                                                <ng-container *ngFor="let compound of compoundList">
                                                                  <span 
                                                                    *ngIf="checkThc(getCompoundValue(compound.min, data?.productDetails), getCompoundValue(compound.max, data?.productDetails))" 
                                                                    class="thc-tag-new">
                                                                    {{ compound.label }}&nbsp;
                                                                    <span *ngIf="checkZero(getCompoundValue(compound.min, data?.productDetails))">
                                                                      {{ getCompoundValue(compound.min, data?.productDetails) }}{{ thcType(data?.productDetails?.ThcType) }}-
                                                                    </span>
                                                                    <span *ngIf="checkZero(getCompoundValue(compound.max, data?.productDetails))">
                                                                      {{ getCompoundValue(compound.max, data?.productDetails) }}{{ thcType(data?.productDetails?.ThcType) }}&nbsp;
                                                                    </span>
                                                                    <span *ngIf="checkZero(getCompoundValue(compound.sum, data?.productDetails))">&nbsp;({{getCompoundValue(compound.sum, data?.productDetails) }})&nbsp;</span>
                                                                  </span>
                                                                </ng-container>
                                                            </div>

                                                                <div id="{{data?.CatalogItemId}}" *ngIf="varianceArray?.length>0">
                                                                    <div id='welcomeDiv' class="answer_list" [ngStyle]="{'display':(isShown && (actualId == data?.CatalogItemId) && showVariance)?'block':'none'}">
                                                                        <input type="button" name="answer" value="" style="background: url(assets/images/close.png);" (click)="showDiv1(data?.CatalogItemId)" class="hideproducttag">
                                                                        <h3>Select an option </h3>
                                                                        <div *ngFor="let data of varianceArray;let i= index;">
                                                                            <div class="tag">
                                                                                <div class="row" (click)="HandleVarinceAddToCartOrNot(data,1)" style="cursor: pointer;">
                                                                                    <div class="col-4">
                                                                                        <p class="gram">
                                                                                            {{data?.productDetails?.ProductName}}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div class="col-8">

                                                                                        <div *ngIf="!auth" class='increase-qty' [ngStyle]="{'display':(this.VARID  === data?._id )?'block':'none'}">
                                                                                            <a disabled="varqtyvalue <= 1">
                                                                                                <img style="cursor:grab" src="assets/images/minus-black.png" (click)="increaseDecreaseOfflineProductforvar(data.CatalogItemId,data.optionId,data.optionTypeId,'simple',1,false,data.productDetails.EquivalentToVal,data,data?.productDetails?.HeroShotUri,i)" alt="">
                                                                                            </a>
                                                                                            <input type="text" [(ngModel)]='varqtyvalue' id="qty" value="1" disabled class='form-control' />
                                                                                            <img style="cursor:grab" src="assets/images/add-black.png" alt="" (click)="increaseDecreaseOfflineProductforvar(data.CatalogItemId,data.optionId,data.optionTypeId,'simple',1,true,data.productDetails.EquivalentToVal,data,data?.productDetails?.HeroShotUri,i)">
                                                                                        </div>
                                                                                        <div *ngIf="auth" class='increase-qty' [ngStyle]="{'display':(this.VARID  === data?._id )?'block':'none'}">
                                                                                            <a disabled="varqtyvalue <= 1">
                                                                                                <img style="cursor:grab" src="assets/images/minus-black.png" (click)="addToCartvar(data,false)" alt="">
                                                                                            </a>
                                                                                            <input type="text" [(ngModel)]='varqtyvalue' id="qty" value="1" disabled class='form-control' />
                                                                                            <img style="cursor:grab" src="assets/images/add-black.png" alt="" (click)="addToCartvar(data,true)">
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </figure>
                                                            <div class="product-body product-body-staff">
                                                                <h5 class="brand-name-product">
                                                                    {{data?.productDetails?.brand?.brandName?data?.productDetails?.brand?.brandName:"Brand Name"}}
                                                                </h5>
                                                                <h3 class="product-title">
                                                                    <a class="cursor" (click)="redirectToDetailPage(data.productslug)">
                                                                        {{data.productDetails?.ProductName}}</a>
                                                                </h3>

                                                                <div class="product-price1">
                                                                    {{data?.price | currency :'USD'}}
                                                                </div>
                                                               
                                                                <div class="row add-strang-item"  style="margin:0; padding: 0;" *ngIf="data?.productDetails?.tags?.length">
                                                                    <div class="col-6" *ngFor="let tag of data.productDetails.tags | slice:0:4">
                                                                      <div class="add-strang-part1" *ngIf="tag?.tagName" [ngStyle]="{ background: getBackGroundColor(tag) }" [matTooltip]="tag.tagName">
                                                                        {{ tag.tagName }}
                                                                      </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                            <div class="checkout-bitton-in-cart">
                                <h5 style=" margin: 25px 45px;">Ready to place your order? Sign In or continue as Guest.
                                </h5>
                                <div class="row align-items-center left-right-marg">
                                    <div class="col-6">
                                        <a class="cursor" (click)="redirectToCheckOutPage('login')" [class.float-none]="offineDiscountNumber!==0">Sign In/Register</a>
                                    </div>
                                    <div class="col-6">
                                        <a class="cursor" (click)="ShowGuestOptionFirst()">Guest</a>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div *ngIf="auth">
                        <ng-container *ngIf="auth && !canShowThankyoupage">
                            <span class='outOfStockMessage' *ngIf="outOfStockMessage!==''">{{outOfStockMessage}}</span>
                            <ng-container *ngIf="cartProduct">
                                <div *ngIf="cartLength===0||cartProduct.msg==='Cart is empty!'">
                                    <div style=' text-align: center;margin-top: 5%;'>
                                        <h6 class="empty_msg">No items in cart to display</h6>
                                        <h4 class="light_msg">Hey, its feel so light</h4>
                                        <img src="assets/images/cart.png" class="cartImage" style='margin:auto; margin-bottom: 10px;'>
                                        <p class="nothing_msg">There is nothing in your bag. Let's add some items.</p>
                                    </div>
                                </div>
                                <!---------------------------------------------------------------//user cart-------------------------------------------------------------------------------------------------------------------------->
                                <div class="cart-products" *ngIf="cartLength!==0 && !loginModeOn">
                                    <ul class='cartDivScrollable'>
                                        <ng-container *ngIf="cartProduct['data']">
                                            <ng-container *ngFor="let product of cartProduct['data']?.addtoCart;">
                                                <li>
                                                    <div class="row align-items-center left-right-marg">
                                                        <div class="col-2">
                                                            <a (click)="redirectToDetailPage(product.productslug)" [routerLink]="">
                                                                <img class="image_shop" [src]="product.HeroShotUri? product.HeroShotUri : defaultUrl">
                                                            </a>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="product-name">{{product?.productName}} </div>

                                                        </div>
                                                        <div class="col-3">
                                                            <div>
                                                                <div class='select-custom'>
                                                                    <div style="cursor:pointer;" *ngIf="product?.selectQuantity >= 2" class="value-button" id="decrease" value="Decrease Value" (click)="increaseDecreaseQuantity(product.Id,product.optionId,product.optionTypeId,product.productType,product.EquivalentToVal,product.productName,$event, product.inventoryId,product.selectQuantity,false,product)">
                                                                        <img style="cursor:pointer;" src="assets/images/minus-black.png" alt="" style="width: 10px; height: auto; display: inline-block;">
                                                                    </div>
                                                                    <div style="cursor:pointer;" *ngIf="product?.selectQuantity ==1" class="value-button" id="delete" (click)="removeProduct(product._id,product.productId,true)">
                                                                        <span class="fa fa-trash" style="font-size: 13px; color: #fff;">
                                                                            <a class="delete-item-product">
                                                                                <img style="cursor:grab" src="assets/images/bin.png" alt="" style="width: 13px; height: auto; display: inline-block;">
                                                                            </a>
                                                                        </span>
                                                                    </div>
                                                                    <input type="text" id="qty" value="0" class='form-control' [(ngModel)]='product.selectQuantity' disabled />
                                                                    <div style="cursor:pointer;" class="value-button" id="increase" value="Increase Value" (click)="increaseDecreaseQuantity(product.Id,product.optionId,product.optionTypeId,product.productType,product.EquivalentToVal,product.productName,$event, product.inventoryId,product.selectQuantity,true,product)">
                                                                        <img style="cursor:grab" src="assets/images/add-black.png" alt="" style="width: 10px; height: auto; display: inline-block;">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-2">
                                                            <div class="product-price1">
                                                                <div class="product-qty">
                                                                    <div class="price">
                                                                        <span *ngIf="product.purchaseStatus==='purchase'">{{product.productTitle}}</span>
                                                                        <span [class.margin-left-12]="product.productType==='simple'">{{product.price | currency:'USD'}}
                                                                        </span>
                                                                        <br>
                                                                        <span *ngIf="product.myPrice>product.price" style="display:inline-block; font-size: 13px;color: #000;font-weight: 600;text-decoration: line-through;">{{product.myPrice | currency:'USD'}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-1">
                                                            <a (click)="removeProduct(product._id,product.productId,true)" class="delete-item-product">
                                                                <i class="fa fa-close">
                                                                </i>
                                                            </a>
                                                        </div>

                                                    </div>
                                                </li>
                                            </ng-container>
                                        </ng-container>
                                    </ul>
                                    <div class="total-price" *ngIf="cartLength!==0" [class.text-align-right]='cartProduct.discount!==0'>
                                        <div class="order-total" style="width:100%" [class.col-width]="cartProduct.discount!==0">
                                            <div class="row">
                                                <div class='col-9' style="text-align: right;">
                                                    <ul class="total-discount-bottom">
                                                        <li><span>Subtotal</span></li>

                                                        <li><span>Tax </span></li>
                                                        <li *ngIf="auth && cartProduct?.discount > 0" [ngStyle]="{'line-height':promoCodeAppilied ?'20px':'37px'}"> <span>Discount </span>
                                                            <p *ngIf="promoCodeAppilied">
                                                                <span *ngFor="let item of logincartProduct?.discountLabel" style="font-size: 10px; "><b>{{item}}</b> </span>
                                                            </p>
                                                        </li>
                                                        <li><span style="font-weight:bold !important;">Total Order
                                                            </span></li>

                                                    </ul>
                                                </div>
                                                <div class='col-3'>
                                                    <ul class="total-discount-bottom">
                                                        <li><span>{{cartProduct?.subTotal| currency:'USD'}} </span>
                                                        </li>

                                                        <li><span>{{cartProduct.tax | currency:'USD'}} </span></li>
                                                        <li *ngIf="cartProduct?.discount > 0" [ngStyle]="{'line-height':promoCodeAppilied ? '40px':'20px'}"><span>{{cartProduct?.discount | currency:'USD'}} </span></li>

                                                        <li><span style="font-weight:bold !important;">{{cartProduct.grandTotal | currency:'USD'}}</span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                    <div class="recommended-for-you" *ngIf="recommendedProductsList?.length && auth && showLoginStaffPick ">
                                        <h6>Staff Picks </h6>
                                        <div class="list-of-product">
                                            <div class="row  left-right-marg" style="margin: 0; width:100%">
                                                <div class="staff-list" style="width:100%">
                                                    <ul class="staff-ul">
                                                        <li class="col-6 staff-li" *ngFor="let data of recommendedProductsList;let x = index ">
                                                            <div class="product product-11 text-center " (mouseleave)="setemptyHoverValue(x)" (mouseover)="setNewArrivalValue(x)" [ngStyle]="{'backgroundColor':getBackGroundColorAccToSpecies(data?.productDetails?.species)}">
                                                                <div class="product-details-action">
                                                                    <a href="javascript:;">
                                                                        <img src="assets/images/add1.png" (click)="addSelectedVariance(data)" alt="">
                                                                    </a>
                                                                </div>
                                                                <figure class="product-media">
                                                                    <div *ngIf="data?.productDetails?.species?.length">
                                                                        <div class=" tag-name-indica" *ngIf="data?.productDetails?.species[0]['speciesName'] === 'INDICA'">I</div>
                                                                        <div class="tag-name-sativa" *ngIf="data?.productDetails?.species[0]['speciesName'] === 'SATIVA'">S</div>
                                                                        <div class="tag-name-hybrit" *ngIf="data?.productDetails?.species[0]['speciesName'] === 'HYBRID'">H</div>
                                                                    </div>
                                                                    <a (click)="redirectToDetailPage(data.productslug)" class="cursor">
                                                                        <img [src]="getImageSize3(data?.productDetails?.Assets)" alt="" class="product-image  Staff_Picks_Img">
                                                                    </a>
                                                                    <div class="Sale_tag_parent">
                                                                        <div class="Sale_new" *ngIf="data.myPrice>data.price">
                                                                            SALE</div>
                                                                    </div>
                                                                    
                                                                    <div class="thc-tag-new1">
                                                                        <ng-container *ngFor="let compound of compoundList">
                                                                          <span 
                                                                            *ngIf="checkThc(getCompoundValue(compound.min, data?.productDetails), getCompoundValue(compound.max, data?.productDetails))" 
                                                                            class="thc-tag-new">
                                                                            {{ compound.label }}&nbsp;
                                                                            <span *ngIf="checkZero(getCompoundValue(compound.min, data?.productDetails))">
                                                                              {{ getCompoundValue(compound.min, data?.productDetails) }}{{ thcType(data?.productDetails?.ThcType) }}-
                                                                            </span>
                                                                            <span *ngIf="checkZero(getCompoundValue(compound.max, data?.productDetails))">
                                                                              {{ getCompoundValue(compound.max, data?.productDetails) }}{{ thcType(data?.productDetails?.ThcType) }}&nbsp;
                                                                            </span>
                                                                            <span *ngIf="checkZero(getCompoundValue(compound.sum, data?.productDetails))">&nbsp;({{getCompoundValue(compound.sum, data?.productDetails) }})&nbsp;</span>
                                                                          </span>
                                                                        </ng-container>
                                                                    </div>

                                                                    <div id="{{data?.CatalogItemId}}" *ngIf="varianceArray?.length>0">
                                                                        <div id='welcomeDiv' class="answer_list" [ngStyle]="{'display':(isShown && (actualId == data?.CatalogItemId) && showVariance)?'block':'none'}">
                                                                            <input type="button" name="answer" value="" style="background: url(assets/images/close.png);" (click)="showDiv1(data?.CatalogItemId)" class="hideproducttag">
                                                                            <h3>Select an option </h3>
                                                                            <div *ngFor="let data of varianceArray;let i= index;">
                                                                                <div class="tag">
                                                                                    <div class="row" (click)="HandleVarinceAddToCartOrNot(data,1)" style="cursor: pointer;">
                                                                                        <div class="col-4">
                                                                                            <p class="gram">
                                                                                                {{data?.productDetails?.NetWeight}}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div class="col-8">
                                                                                            <p class="gram" *ngIf="this.VARID!= data?._id " style="text-align: right;">
                                                                                                ${{data?.price}}</p>
                                                                                            <div *ngIf="!auth" class='increase-qty' [ngStyle]="{'display':(this.VARID  === data?._id )?'block':'none'}">
                                                                                                <a disabled="varqtyvalue <= 1">
                                                                                                    <img style="cursor:grab" src="assets/images/minus-black.png" (click)="increaseDecreaseOfflineProductforvar(data.CatalogItemId,data.optionId,data.optionTypeId,'simple',1,false,data.productDetails.EquivalentToVal,data,data?.productDetails?.HeroShotUri,i)" alt="">
                                                                                                </a>
                                                                                                <input type="text" [(ngModel)]='varqtyvalue' id="qty" value="1" disabled class='form-control' />
                                                                                                <img style="cursor:grab" src="assets/images/add-black.png" alt="" (click)="increaseDecreaseOfflineProductforvar(data.CatalogItemId,data.optionId,data.optionTypeId,'simple',1,true,data.productDetails.EquivalentToVal,data,data?.productDetails?.HeroShotUri,i)">
                                                                                            </div>
                                                                                            <div *ngIf="auth" class='increase-qty' [ngStyle]="{'display':(this.VARID  === data?._id )?'block':'none'}">
                                                                                                <a disabled="varqtyvalue <= 1">
                                                                                                    <img style="cursor:grab" src="assets/images/minus-black.png" (click)="addToCartvar(data,false)" alt="">
                                                                                                </a>
                                                                                                <input type="text" [(ngModel)]='varqtyvalue' id="qty" value="1" disabled class='form-control' />
                                                                                                <img style="cursor:grab" src="assets/images/add-black.png" alt="" (click)="addToCartvar(data,true)">
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </figure>
                                                                <div class="product-body product-body-staff">

                                                                    <h3 class="product-title">
                                                                        <a (click)="redirectToDetailPage(data.productslug)">
                                                                            {{data.productDetails?.ProductName}}</a>
                                                                    </h3>

                                                                    <div class="product-price">
                                                                        {{data?.price | currency :'USD'}}
                                                                    </div>

                                                                    <span *ngIf="data.myPrice>data.price" style="display:inline-block; font-size: 13px;color: #000;font-weight: 600;text-decoration: line-through;">{{data.myPrice  | currency :'USD'}}</span>
                                                                    
                                                                    <div class="row add-strang-item"  style="margin:0; padding: 0;" *ngIf="data?.productDetails?.tags?.length">
                                                                        <div class="col-6" *ngFor="let tag of data.productDetails.tags | slice:0:4">
                                                                          <div class="add-strang-part1" *ngIf="tag?.tagName" [ngStyle]="{ background: getBackGroundColor(tag) }" [matTooltip]="tag.tagName">
                                                                            {{ tag.tagName }}
                                                                          </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="checkout-bitton-in-cart">
                                        <div class="row align-items-center left-right-marg">
                                            <div class="col-12">
                                                <a href="javascript:;" (click)="redirectToCheckOutPage('checkout')" class="checkout-button" [class.float-none]="cartProduct.discount!==0">Checkout </a>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </ng-container>
                        </ng-container>

                    </div>

                </div>
                <div *ngIf="step==2">

                    <div class="cart-checkout">


                        <div class="special-instructions">

                            <!-- delivery -->
                            <div class="col-12">
                                <h3 class="check_text ml-10">SELECT YOUR OPTION </h3>

                                <div class="pick-up-options">
                                    <div *ngIf="manageOrderOption('Pickup')" class="form-group ml-10" style="margin:0px 25px 8px 0px;">
                                        <input (change)="openstorepop('PICKUP')" type="radio" id="instores" [checked]="radiobtnonFor_inStore" name="options"><label for="">In-Store</label>
                                    </div>
                                    <div *ngIf="manageOrderOption('CurbsidePickup')" class="form-group ml-10" style="margin:0px 25px 8px 0px;">
                                        <input (change)="openstorepop('CURBSIDE')" type="radio" id="curbsides" [checked]="!radiobtnonFor_inStore" name="options"><label for="">Curbside
                                        </label>
                                    </div>
                                    <div *ngIf="manageOrderOption('Delivery')" class="form-group ml-10" style="margin:0px 25px 8px 0px;">
                                        <input (change)="openstorepop('DELIVERY')" type="radio" id="deliverys" [checked]="isDelivery" name="options"><label for="">Delivery
                                        </label>
                                    </div>


                                </div>
                                <span *ngIf="isOptionSubmitted && addressString==='' && isDelivery" class="newLabelSize" style="font-size:14px; color:red;">Enter delivery location</span>


                                <div class="Select_loc_Store" *ngIf="isDelivery">
                                    <form action="#" class="" id="address_search">
                                        <div class="card-body align-items-center" style="padding: 0; position: relative;">

                                            <!-- <input value="{{addressString}}" placeholder="Enter your address"
                                                ngx-google-places-autocomplete #placesRef="ngx-places" [options]="{
                                                    types: [],
                                                    componentRestrictions: { country: ['CA', 'USA']}
                                                    }" (onAddressChange)="handleAddressChangeDelivery($event)"
                                                class="form-control form-control" /> -->
                                            <input type="text" (keyup)="getAddresss($event)" (click)="addressField =true" class="form-control" [(ngModel)]="addressString" [ngModelOptions]="{standalone: true}" name="" placeholder="Enter Your Delivery Address">
                                            <ng-container *ngIf="addressField && tomaddressData?.length>0">
                                                <div id="DivOut" class="address-sug">
                                                    <ul style="list-style: none;">
                                                        <li class="searchinheader" *ngFor="let item of tomaddressData" style="display: flex;align-items: center;">
                                                            <a class="text_mobile_search" (click)="chooseAddressForMapBox(item)"> <i class="fa fa-map-marker"></i> {{item?.place_name}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                        <br>

                        <div class="same-day-delivey">
                            <div class='scrollableDiv'>
                                <ng-container *ngFor="let list of dateArray;let i=index">
                                    <div style="display: inline-block;">
                                        <div class='dateDivSection' [class.activeDiv]="this.selectedDay===list.day" style='cursor: pointer;' (click)='showSlotAccordingToDate(list.date,list.day,list.same,list.milliSecond,i)'>
                                            <div style="text-align: center;">
                                                <span class="fontJust"><b style='text-transform: uppercase;'>{{list.same===0?"Today":getThreeLetterDay(list.day)}}</b></span>
                                            </div>
                                            <div style="text-align: center;">
                                                <span class="fontJust">{{list.date | date:"LLL dd"}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="window-text">
                            Please allow 4-5 hours window for delivery
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-6" appearance="outline">
                                <mat-label class="newLabelSize" style="font-size:14px;">Select time slot</mat-label>
                                <mat-form-field style="display: contents;" appearance="outline">
                                    <select (change)="onChange($event,timiSelected)" matNativeControl required id="selectMonth" [(ngModel)]="timiSelected">
                                        <option disabled>Select</option>
                                        <option *ngFor="let timing of timeSlotArray" value="{{timing.value}}">
                                            {{mynewStoreHoursFormat(timing.value)}}</option>
                                    </select>
                                </mat-form-field>
                                <p style="color:red;">{{timeSlotErr}}</p>

                            </div>
                            <p style="color: red" *ngIf="!timeSlotArray?.length">There is no time slot available at current date</p>

                        </div>

                        <form [formGroup]="guestAddForm" *ngIf="!auth && guestAddForm">
                            <h6>Personal Details</h6>


                            <div class="row">
                                <div class="guest-from">
                                    <div class="row align-items-center left-right-marg">
                                        <div class="col-6">
                                            <div class="form-group">
                                                <input type="text" (keyup)="phoneNumberErrorHandler('$event','firstname')" class="form-control" (keypress)="lettersOnly($event)" formControlName="firstName" name="permo" autocomplete="do-not-autofill" placeholder="First Name">
                                                <p class="text-danger" style="font-size: 10px;margin-top: 5px;">
                                                <div *ngIf="submitted && pf.firstName.errors">
                                                    <div *ngIf="pf.firstName.errors.required" class="help-box text-danger" style="font-size:12px;">
                                                        First name is required
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <input (keyup)="phoneNumberErrorHandler('$event','lastname')" class="form-control" type="text" formControlName="lastName" name="permo" autocomplete="do-not-autofill" placeholder="Last Name" (keypress)="lettersOnly($event)">
                                                <p class="text-danger" style="font-size: 10px;margin-top: 5px;">
                                                <div *ngIf="submitted && pf.lastName.errors">
                                                    <div *ngIf="pf.lastName.errors.required" class="help-box text-danger" style="font-size:12px;">
                                                        Last name is required
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <input type="text" class="form-control" (keyup)="phoneNumberErrorHandler('$event','email')" formControlName="email" name="permo" autocomplete="do-not-autofill" placeholder="Email" (keypress)="spaceNotAllowed($event)">
                                                <div *ngIf="submitted && pf.email.errors">
                                                    <div *ngIf="pf.email.errors.required" class="help-box text-danger" style="font-size:12px;">
                                                        Email Id is required
                                                    </div>
                                                    <div *ngIf=" pf.email.errors.pattern" class="help-box text-danger" style="font-size:12px;">
                                                        Enter correct Email ID
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <input type="tel" maxlength="10" class="form-control" (keyup)="phoneNumberErrorHandler('$event','mobile')" name="permo" formControlName="mobile" autocomplete="do-not-autofill" placeholder="Phone No." (keypress)="onKeypressing($event)">
                                                <p class="text-danger" style="font-size: 10px;margin-top: 5px;">
                                                <div *ngIf="submitted && pf.mobile.errors">
                                                    <div *ngIf="pf.mobile.errors.required" class="help-box text-danger" style="font-size:12px;">
                                                        Mobile is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div *ngIf="isDelivery" class="row">
                            <h6 style="margin:10px">Please add any special instructions such as Unit# and/or Buzzer
                                Codes</h6>
                            <div class="col-md-12">
                                <textarea placeholder="Add any special instruction" [(ngModel)]="deliveryInstruction" name="comment" id="deliveryInstruction" class="form-control"></textarea>
                            </div>
                            <div class="col-md-12" *ngIf="freeDelivery?.isdelivery && freeDelivery?.deliveryCharges > 0 && optionType =='DELIVERY'">
                                <div class="freeDeliveryText">
                                    <div class="row">
                                        <div class="col-2">
                                            <figure>
                                                <img *ngIf="freeDelivery?.freeDeliveryAmount > CartSubTotal" src="assets/images/delivery.png" alt="Free delivery locked">
                                                <img *ngIf="freeDelivery?.freeDeliveryAmount < CartSubTotal" src="assets/images/unlock.png" alt="Free delivery unlocked">
                                            </figure>
                                        </div>
                                        <div class="col-10">
                                            <div class="textfree" *ngIf="freeDelivery?.freeDeliveryAmount > CartSubTotal">
                                                <h5>FREE Delivery on orders over {{freeDelivery?.freeDeliveryAmount| currency:'USD'}}</h5>
                                                <!-- <p>Add product wroth {{freeDelivery?.freeDeliveryAmount - CartSubTotal | currency:'USD'}} more</p> -->
                                            </div>
                                            <div class="textfree" *ngIf="freeDelivery?.freeDeliveryAmount < CartSubTotal">
                                                <h5>Yay! you got FREE Delivery</h5>
                                                <p>No Delivery Fee Needed</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <button *ngIf="auth" (click)="cartValueCheck(0,CartSubTotal)" class="shadow1 proceed-to-checkout cursor">Proceed to checkout</button>
                        <button *ngIf="!auth" (click)="cartValueCheck(1,guest_subtotal)" class="shadow1 proceed-to-checkout cursor">Proceed to checkout</button>
                        <a *ngIf="auth" (click)="backFrom_checkout_auth()" class="GO_BACK cursor"> <img src="assets/images/left-arrow.png" alt=""> Go Back</a>
                        <a *ngIf="!auth" (click)="backFrom_checkout_guest()" class="GO_BACK cursor"> <img src="assets/images/left-arrow.png" alt=""> Go Back</a>
                    </div>




                </div>
                <div *ngIf="step==3">
                    <div class="guest-user-cart" *ngIf="!auth">

                        <div class="pricing-details">
                            <div class="row">
                                <div class="col-6">
                                    <ul>
                                        <li><b>Subtotal </b></li>
                                        <li><b>Tax</b></li>
                                        <li *ngIf="optionType =='DELIVERY' && freeDelivery?.isdelivery">Delivery Charge</li>

                                        <li><b>Grand Total </b></li>
                                    </ul>
                                </div>
                                <div class="col-6">
                                    <ul style="text-align: right">

                                        <li><span style="font-weight:bold !important;">
                                                {{guestSubTotal | currency :'USD'}}
                                            </span>
                                        </li>
                                        <li><span style="font-weight:bold !important;">{{(guestTax?guestTax:0) | currency :'USD'}}
                                            </span></li>
                                        <li *ngIf="freeDelivery?.isdelivery && optionType =='DELIVERY'">
                                            <span *ngIf="guestSubTotal >= freeDelivery?.freeDeliveryAmount">
                                                <span style="text-decoration: line-through;">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span> FREE
                                            </span>
                                            <span *ngIf="guestSubTotal < freeDelivery?.freeDeliveryAmount">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span>
                                        </li>

                                        <li><span style="font-weight:bold !important;">{{guestGTotal | currency:'USD'}}
                                            </span></li>

                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div class="row align-items-center left-right-marg">
                            <div class="col-12">
                                <div class="card-option-cast">
                                    <h3 class="newSizeh3" style="text-transform: uppercase; font-weight: 700;font-size: 22px; margin: 10px 0; ">Payment Options</h3>
                                    <div *ngIf="getOptionType() =='PICKUP'" class="form-group" style="margin-bottom: 8px;">
                                        <input type="radio" id="guestcash_radiobtn" name="paymentMethodcash" [checked]="radiobtnonForCash_guest" (change)="getPaymentMethodOption($event,'cash')">
                                        <label for="">Pay In-store</label>
                                    </div>
                                    <!-- <div *ngIf="getOptionType() =='DELIVERY'" class="form-group" style="margin-bottom: 8px;">
                                        <input type="radio" id="guestcash_radiobtn" name="paymentMethodcash" [checked]="radiobtnonForCash_guest" (change)="getPaymentMethodOption($event,'cash')">
                                        <label for="">Cash on Delivery</label>
                                    </div> -->
                                    <div *ngIf="getOptionType() !='PICKUP' && siteDada?.paymentGatewayInfo == 'Aeropay'">
                                        <input type="radio" [checked]="radiobtnonForCash_guest" (change)="getPaymentMethodOption($event, 'cash')" />

                                        <img style="display: inline-block; height: 20px;width: auto; position: relative;top: -3px;margin-left: 5px;" src="assets/images/aeropay.png" alt="">
                                        <p class="RedLineBank">
                                            <span class="secure_text">Secure, no-fee payments. Simply link your bank and pay.</span>
                                            <img style="display: inline-block; height: 30px;width: auto; position: relative; top: -3px;" src="assets/images/banks.jpg" alt="">
                                            <span class="s_more">+1000s more</span>

                                        </p>
                                    </div>

                                    <div class="form-group" *ngIf="getOptionType() !='PICKUP' && siteDada?.paymentGatewayInfo != 'Aeropay'">
                                        <input type="radio" id="guestCredit_radiobtn" [checked]="!radiobtnonForCash_guest" name="paymentMethodcash" (change)="getPaymentMethodOption($event,'creditcard')">
                                        <label for="">Pay Now</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="guest-from">
                            <form>
                                <div class="row align-items-center left-right-marg">

                                    <div *ngIf="!radiobtnonForCash_guest" class="col-12" style="margin-bottom:10px;">
                                        <div class="col-12">
                                            <h5 class="check_text">Card Details </h5>
                                            <hr style="margin: 0px 0px 15px 0px;">
                                            <p class="check_text" style="font-size: 20px; margin-bottom: 10px;">We accept </p>
                                            <div style="display: flex;">
                                                <img src="assets/images/visa.png" style="width:auto;height: 30px !important; margin-right: 10px;margin-bottom: 10px;">
                                                <img src="assets/images/mastercard.png" style="width:auto;height: 30px !important; margin-right: 10px;margin-bottom: 10px;">
                                            </div>
                                        </div>
                                        <br>
                                        <div class="col-12">
                                            <form *ngIf="CreditCardForm_guest" [formGroup]="CreditCardForm_guest">
                                                <div class="col-12">
                                                    <mat-label class="newLabelSize" style="font-size:14px;">Card Number
                                                    </mat-label>
                                                    <mat-form-field style="display: contents;" appearance="outline">
                                                        <input class="newLabelSize" (keydown)="onKeydownMain($event)" matInput #userCard maxlength="16" (keyup)="GetCardType($event.target.value)" formControlName="cardnumber_guest" required onkeypress='return event.charCode >= 48 && event.charCode <= 57' placeholder="XXXX-XXXX-XXXX-XXXX" autocomplete="do-not-autofill" (keypress)="onKeypressing($event)">
                                                        <img class="cardImg" *ngIf="cardImage !=''" [src]="cardImage">

                                                        <mat-hint align="end">{{userCard.value?.length || 0}}/16
                                                        </mat-hint>


                                                        <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.cardnumber_guest?.errors">
                                                            <div *ngIf="F?.cardnumber_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Card number is required</div>
                                                            <div *ngIf="F?.cardnumber_guest?.errors?.minlength" class="help-box text-danger" style="font-size:12px;"> Card number must be at least 16 digit long.</div>
                                                        </div>
                                                    </mat-form-field>



                                                </div>
                                                <div style="display: flex;">
                                                    <div class="col-8" style="margin-top:10px;">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">Expiry Month</mat-label>:
                                                        <div class="flex" style="display:flex;">
                                                            <div class="col-6" style="margin: 10px 0 10px -3%;">
                                                                <mat-form-field style="display: contents;" appearance="outline">
                                                                    <select matNativeControl  name="guestForm" formControlName="expiryMonth_guest" required id="selectMonth">
                                                                        <option [value]="null" disabled selected>Month</option>
                                                                        <option *ngFor="let month of monthlist" [value]="month.value">{{month.text}}
                                                                        </option>
                                                                    </select>

                                                                    <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.expiryMonth_guest?.errors">
                                                                        <div *ngIf="F?.expiryMonth_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Month is required</div>
                                                                    </div>

                                                                </mat-form-field>

                                                            </div>

                                                            <div class="col-6" style="margin: 10px 0 10px -3%;">
                                                                <mat-form-field style="display: contents;" appearance="outline">
                                                                    <select matNativeControl formControlName="expiryYear_guest" (change)="checkYears($event.target.value)"  name="guest1" required id="selectMonth">
                                                                        <option [value]="null" disabled selected>Year</option>
                                                                        <option *ngFor="let year of years" [value]="year.value">
                                                                            {{year.text}}</option>
                                                                    </select>
                                                                    <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.expiryYear_guest?.errors">
                                                                        <div *ngIf="F?.expiryYear_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Year is required</div>
                                                                    </div>

                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4" style="margin-top:16px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">CVV
                                                        </mat-label>
                                                        <mat-form-field style="display: contents;">
                                                            <input class="newLabelSize" autocomplete="do-not-autofill" (keypress)="onKeypressing($event)" formControlName="cvv_guest" type="text" matInput #userCvv maxlength="3" required style="border:none !important;">
                                                            <mat-hint align="end">{{userCvv.value?.length || 0}}/3
                                                            </mat-hint>
                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.cvv_guest?.errors">
                                                                <div *ngIf="F?.cvv_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">CVV is required</div>
                                                                <div *ngIf="F?.cvv_guest?.errors?.minlength" class="help-box text-danger" style="font-size:12px;"> CVV must be at least 3 digit long.</div>

                                                            </div>

                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <h5 class="check_text">Credit Card Billing Details</h5>
                                                <div class="row">
                                                    <div class="col-6" style="margin-top:10px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">First
                                                            Name</mat-label>
                                                        <mat-form-field style="display: contents;">
                                                            <input class="newLabelSize" autocomplete="do-not-autofill" (keypress)="lettersOnly($event)" type="text" matInput #firstname_guest formControlName="firstname_guest" required style="border:none !important;">

                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.firstname_guest?.errors">
                                                                <div *ngIf="F?.firstname_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">First name is required</div>

                                                            </div>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-6" style="margin-top:10px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">Last
                                                            Name</mat-label>
                                                        <mat-form-field style="display: contents;">
                                                            <input class="newLabelSize" autocomplete="do-not-autofill" type="text" matInput #lastname_guest formControlName="lastname_guest" required style="border:none !important;" (keypress)="lettersOnly($event)">
                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.lastname_guest?.errors">
                                                                <div *ngIf="F?.lastname_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Last name is required</div>

                                                            </div>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-6" style="margin-top:10px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">Email
                                                        </mat-label>
                                                        <mat-form-field style="display: contents;">
                                                            <input class="newLabelSize" autocomplete="do-not-autofill" type="text" matInput #email_guest formControlName="email_guest" required style="border:none !important;" (keypress)="spaceNotAllowed($event)">
                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.email_guest?.errors">
                                                                <div *ngIf="F?.email_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Email is required</div>
                                                                <div *ngIf="F?.email_guest.errors.pattern" class="help-box text-danger" style="font-size:12px;">
                                                                    Enter correct Email
                                                                </div>
                                                            </div>


                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-6" style="margin-top:10px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">Phone
                                                            Number</mat-label>
                                                        <mat-form-field style="display: contents;">
                                                            <input class="newLabelSize" autocomplete="do-not-autofill" (keypress)="onKeypressing($event)" type="text" matInput #phone_guest formControlName="phone_guest" required style="border:none !important;" maxlength="10">
                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.phone_guest?.errors">
                                                                <div *ngIf="F?.phone_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Phone number is required</div>
                                                                <div *ngIf="F?.phone_guest?.errors?.minlength" class="help-box text-danger" style="font-size:12px;"> Phone number be at least 10 digit long.</div>

                                                            </div>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="row">

                                                    <div class="col-8" style="margin-top:10px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">Street
                                                            Address</mat-label>
                                                        <mat-form-field style="display: contents;">
                                                            <input class="newLabelSize" autocomplete="do-not-autofill" type="text" matInput #postalCode formControlName="street_address_guest" required style="border:none !important;" (keypress)="firstLaterCaps($event)">
                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.street_address_guest?.errors">
                                                                <div *ngIf="F?.street_address_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Street Address is required</div>

                                                            </div>


                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-4" style="margin-top:10px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">Apt/Suite #
                                                        </mat-label>
                                                        <mat-form-field style="display: contents;">
                                                            <input class="newLabelSize" autocomplete="off" type="text" matInput #postalCode formControlName="apartment" style="border:none !important;" (keypress)="spaceNotAllowed($event)">

                                                        </mat-form-field>
                                                    </div>


                                                    <div class="col-6" style="margin-top:10px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">City
                                                        </mat-label>
                                                        <mat-form-field style="display: contents;">
                                                            <input class="newLabelSize" autocomplete="do-not-autofill" type="text" matInput #postalCode formControlName="city_address_guest" required style="border:none !important;" (keypress)="firstLaterCaps($event)">
                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.city_address_guest?.errors">
                                                                <div *ngIf="F?.city_address_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">City is required</div>

                                                            </div>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-6" style="margin-top:15px;">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">Province
                                                        </mat-label>
                                                        <mat-form-field style="display: contents;" appearance="outline">
                                                            <select matNativeControl formControlName="state_address_guest"  required id="selectMonth">
                                                                <option [value]="null" disabled>Select</option>
                                                                <option *ngFor="let statelists of statelist" [value]="statelists.value">{{statelists.text}}
                                                                </option>
                                                            </select>
                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.state_address_guest?.errors">
                                                                <div *ngIf="F?.state_address_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Province is required</div>

                                                            </div>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-6" style="margin-top:10px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">Country

                                                        </mat-label>
                                                        <mat-form-field style="display: contents;border-bottom: 1px solid rgba(0, 0, 0, 0.42);">
                                                            <input class="newLabelSize" autocomplete="do-not-autofill" type="text" matInput formControlName="country_address_guest" required style="border:none !important;color: #666;">
                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.country_address_guest?.errors">
                                                                <div *ngIf="F?.country_address_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Country is required</div>

                                                            </div>

                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-6" style="margin-top:10px;" appearance="outline">
                                                        <mat-label class="newLabelSize" style="font-size:14px;">Postal Code</mat-label>
                                                        <mat-form-field style="display: contents;">
                                                            <input type="text" class="newLabelSize" autocomplete="do-not-autofill" (keyup)="onKeyUp($event,'pcode_guest')" (paste)="onPaste($event,'guest')" matInput #postalCode maxlength="6" formControlName="pcode_guest" required style="border:none !important; text-transform: capitalize;" (keypress)="spaceNotAllowed($event)">
                                                            <div class="form_placeholder" *ngIf="guestCardSubmitted && F?.pcode_guest?.errors">
                                                                <div *ngIf="F?.pcode_guest?.errors?.required" class="help-box text-danger" style="font-size:12px;">Postal Code is required</div>
                                                                <div *ngIf="F?.pcode_guest?.errors?.minlength" class="help-box text-danger" style="font-size:12px;"> Postal Code length must be at least 6 </div>

                                                            </div>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="col-12" style="margin-top: 10px;">
                                        <button type="submit" id="contBTN" (click)="GuestAdd()">
                                            <span>continue </span>
                                        </button>
                                        <a (click)="backFrom_Guest_credit()" class="GO_BACK cursor"> <img src="assets/images/left-arrow.png" alt=""> Go Back</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div *ngIf="auth" class="cart-checkout">
                        <div *ngIf="guestdilveryShow == 'false' && optionType =='DELIVERY'">
                            <h4>Tip your driver </h4>
                            <div class="tip_driver">
                                <input (click)="calucalte_driverTip(10)" type="radio" class="btn-tip" id="10" name="tips" />
                                <label for="10">10%</label>
                                <input (click)="calucalte_driverTip(15)" type="radio" class="btn-tip" id="15" name="tips" />
                                <label for="15">15%</label>
                                <input (click)="calucalte_driverTip(20)" type="radio" class="btn-tip" id="20" name="tips" />
                                <label for="20">20%</label>
                                <input (click)="calucalte_driverTip(25)" type="radio" class="btn-tip" id="25" name="tips" />
                                <label for="25">25%</label>
                                <input (click)="calucalte_driverTip(30)" type="radio" class="btn-tip" id="30" name="tips" />
                                <label for="30">30%</label>
                                <div class="flex">
                                    <input id="custom_tip" (keyup)="driverCustomTip($event)" name="customTip" placeholder="Dollar Amount">

                                    <button *ngIf="!show_tip_in_cart " (click)="applytip(true)" class="btn btn-primary" style="min-width:100px !important; height:43px;border-radius: 10px;">Apply
                                        Tip</button>
                                    <button *ngIf="show_tip_in_cart" (click)="applytip(false)" class="btn btn-primary" style="min-width:100px !important; height:43px;border-radius: 10px;">Remove
                                        Tip</button>
                                </div>

                            </div>
                        </div>
                        <p style="color: red;font-size: 10px;" *ngIf="invalidTip">You must enter a valid tip</p>
                        <div class="card-option-cast" *ngIf="auth">
                            <h3 class="newSizeh3">Payment Options {{ optionType }}</h3>
                            <div class="form-group" style="margin-bottom: 8px;" *ngIf="getOptionType() =='PICKUP'">
                                <input type="radio" [checked]="radiobtnonForCash_auth" (change)="getPaymentMethodOption($event,'cash')">
                                <label for="">Pay In-store</label>
                            </div>
                            <!-- <div *ngIf="!canShowThankyoupage && getOptionType() =='DELIVERY'" class="form-group" style="margin-bottom: 8px;">
                                <input type="radio" [checked]="radiobtnonForCash_auth"
                                    (change)="getPaymentMethodOption($event,'cash')">
                                <label for="">Cash on Delivery</label>
                                </div> -->

                            <div *ngIf="getOptionType() !='PICKUP' && siteDada?.paymentGatewayInfo == 'Aeropay'">
                                <input type="radio" [checked]="radiobtnonForCash_auth" (change)="getPaymentMethodOption($event, 'cash')" />

                                <img style="display: inline-block; height: 20px;width: auto; position: relative;top: -3px;margin-left: 5px;" src="assets/images/aeropay.png" alt="">
                                <p class="RedLineBank">
                                    <span class="secure_text">Secure, no-fee payments. Simply link your bank and pay.</span>
                                    <img style="display: inline-block; height: 30px;width: auto; position: relative; top: -3px;" src="assets/images/banks.jpg" alt="">
                                    <span class="s_more">+1000s more</span>

                                </p>
                            </div>

                            <div *ngIf="getOptionType() !='PICKUP' && siteDada?.paymentGatewayInfo != 'Aeropay'" class="form-group">
                                <input type="radio" [checked]="!radiobtnonForCash_auth" (change)="getPaymentMethodOption($event,'creditcard')">
                                <label for="">Pay Now</label>
                            </div>
                        </div>
                        <div *ngIf="!canShowThankyoupage && auth && !radiobtnonForCash_auth " class="row">
                            <div class="col-12">
                                <h5 class="check_text">Credit Card Billing Details</h5>
                                <hr style="margin: 0px 0px 15px 0px;">
                                <p class="check_text" style="font-size: 20px; margin-bottom: 10px;">We accept </p>
                                <div style="display: flex;">
                                    <img src="assets/images/visa.png" style="width:auto;height: 30px !important; margin-right: 10px;margin-bottom: 10px;">
                                    <img src="assets/images/mastercard.png" style="width:auto;height: 30px !important; margin-right: 10px;margin-bottom: 10px;">
                                </div>
                            </div>
                            <br>
                            <div class="col-12">
                                <form *ngIf="CreditCardForm_login" [formGroup]="CreditCardForm_login">
                                    <div class="row">
                                        <!-- <div class="col-6" style="margin:15px 0;" appearance="outline">
                                              <button class="add-card-btn" (click)="AddNewCard()">Add New Card</button>
                                          </div> -->
                                        <div class="col-6" *ngIf="CreditCardForm_login?.value?.newCard_user && !CreditCardForm_login?.value?.selectCard" style="margin:15px 0;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Save Card Info
                                            </mat-label>
                                            <input class="newLabelSize form-control Add_New_Card_info" formControlName="saveCard_user" autocomplete="do-not-autofill" type="checkbox" required style="border:none !important;" maxlength="10">

                                        </div>
                                    </div>

                                    <div class="row" *ngIf="creditCardArray?.length">

                                        <div class="col-12" appearance="outline" *ngFor="let item of creditCardArray;let i = index">
                                            <div class="card-information-saved">
                                                <div class="row">
                                                    <div class="col-7">
                                                        <div class="card-left">
                                                            <mat-label class="newLabelSize" style="font-size:14px;">{{cardFOrmatLasr4Digit(item?.cardNum)}}</mat-label>
                                                            <input type="radio" id="card" name="card" class="newLabelSize form-control Add_New_Card_info" (change)="saveCard(item,i,$event.target.value)" formContorlName="selectCard" [checked]="selectedIndex  == i" style="border:none !important;">
                                                            <p *ngIf="item?.firstName"><b>Username:</b> {{item?.firstName | titlecase}}</p>
                                                            <input *ngIf="selectedIndex  === i && CreditCardForm_login?.value?.selectCard" type="password" class="form-control cvvcard-save-info" placeholder="Enter CVV" (click)="patchData(item)" matInput maxlength="3" minlength="3" (keyup)="cvvValue($event)" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" [(ngModel)]="cvvLoginUser" [ngModelOptions]="{standalone: true}">
                                                            <div *ngIf="selectedIndex  === i && loginCardSubmitted && (this.cvvLoginUser =='' || this.cvvLoginUser ==undefined || this.cvvLoginUser ==null || this.cvvLoginUser?.length < 3)" style="margin-top:5px;" class="errorh">
                                                                <p style="color: red;font-size: 12px;">Enter CVV</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-5">
                                                        <div class="card-right">
                                                            <a (click)="addCard()">Add New Card</a>
                                                            <img class="cardImg-new" [src]="GetCardTypes(item?.cardNum)">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="addNewCard">
                                                <app-add-credit-card></app-add-credit-card>
                                            </div>
                                        </div>
                                    </div>



                                    <div class="row" *ngIf="CreditCardForm_login?.value.newCard_user">
                                        <div class="col-6" style="margin-top:10px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">First Name
                                            </mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" autocomplete="do-not-autofill" (keypress)="lettersOnly($event)" type="text" matInput #firstname_login formControlName="firstname_login" required style="border:none !important;">
                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.firstname_login?.errors">
                                                    <div *ngIf="UF?.firstname_login?.errors?.required" class="help-box text-danger" style="font-size:12px;">First Name is required</div>

                                                </div>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6" style="margin-top:10px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Last Name
                                            </mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" autocomplete="do-not-autofill" type="text" matInput #lastname_login formControlName="lastname_login" required style="border:none !important;" (keypress)="lettersOnly($event)">
                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.lastname_login?.errors">
                                                    <div *ngIf="UF?.lastname_login?.errors?.required" class="help-box text-danger" style="font-size:12px;">Last Name is required</div>

                                                </div>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6" style="margin-top:10px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Email</mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" autocomplete="do-not-autofill" (keypress)="spaceNotAllowed($event)" type="text" matInput #email_login formControlName="email_login" required style="border:none !important;">
                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.email_login?.errors">
                                                    <div *ngIf="UF?.email_login?.errors?.required" class="help-box text-danger" style="font-size:12px;">Email is required</div>
                                                    <div *ngIf="UF?.email_login.errors.pattern" class="help-box text-danger" style="font-size:12px;">
                                                        Enter correct Email
                                                    </div>
                                                </div>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6" style="margin-top:10px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Phone Number
                                            </mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" autocomplete="do-not-autofill" (keypress)="onKeypressing($event)" type="text" matInput #phone_login formControlName="phone_login" required style="border:none !important;" maxlength="10">
                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.phone_login?.errors">
                                                    <div *ngIf="UF?.phone_login?.errors?.required" class="help-box text-danger" style="font-size:12px;">Phone Number is required</div>
                                                    <div *ngIf="UF?.phone_login?.errors?.minlength" class="help-box text-danger" style="font-size:12px;"> Phone Numberr must be at least 10 digit long.</div>
                                                </div>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-12" *ngIf="CreditCardForm_login?.value.newCard_user">
                                        <mat-label class="newLabelSize" style="font-size:14px;">Card Number</mat-label>
                                        <mat-form-field style="display: contents;" appearance="outline">
                                            <input class="newLabelSize" autocomplete="do-not-autofill" (keypress)="onKeypressing($event);GetCardType($event.target.value)" formControlName="cardnumber_login" matInput #userCard maxlength="16" required placeholder="XXXX-XXXX-XXXX-XXXX" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                            <img class="cardImg" *ngIf="cardImage !=''" [src]="cardImage">

                                            <mat-hint align="end">{{userCard.value?.length || 0}}/16</mat-hint>
                                            <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.cardnumber_login?.errors">
                                                <div *ngIf="UF?.cardnumber_login?.errors?.required" class="help-box text-danger" style="font-size:12px;">Card number is required</div>
                                                <div *ngIf="UF?.cardnumber_login?.errors?.minlength" class="help-box text-danger" style="font-size:12px;"> Card number must be at least 16 digit long.</div>
                                            </div>
                                        </mat-form-field>
                                    </div>
                                    <div style="display: flex;" *ngIf="CreditCardForm_login?.value.newCard_user">
                                        <div class="col-8" style="margin-top:10px;">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Expiry Month
                                            </mat-label>
                                            <div class="flex" style="display:flex;">
                                                <div class="col-6" style="margin: 10px 0 10px -3%;">
                                                    <mat-form-field style="display: contents;" appearance="outline">
                                                        <select matNativeControl formControlName="expiryMonth_login" id="selectMonth">
                                                            <option [value]="null" selected disabled>Select</option>
                                                             <ng-container *ngFor="let month of monthlist">
                                                                <option  [value]="month.value">{{month.text}}</option>
                                                             </ng-container>
                                                             
                                                        </select>
                                                        <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.expiryMonth_login?.errors">
                                                            <div *ngIf="UF?.expiryMonth_login?.errors?.required" class="help-box text-danger" style="font-size:12px;">Expiry Month is required</div>
                                                        </div>
                                                    </mat-form-field>
                                                </div>
                                                <div class="col-6" style="margin: 10px 0 10px -3%;">
                                                    <mat-form-field style="display: contents;" appearance="outline">
                                                        <select matNativeControl formControlName="expiryYear_login" (change)="checkYears($event.target.value)" id="selectMonth">
                                                            <option [value]="null" selected disabled>Select</option>
                                                            <option *ngFor="let year of years" [value]="year.value">
                                                                {{year.text}}</option>
                                                        </select>
                                                        <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.expiryYear_login?.errors">
                                                            <div *ngIf="UF?.expiryYear_login?.errors?.required" class="help-box text-danger" style="font-size:12px;">Expiry Year is required</div>
                                                        </div>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4" style="margin-top:16px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">CVV</mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" formControlName="cvv_login" type="password" matInput #userCvv maxlength="3" minlength="3" style="border:none !important;">
                                                <mat-hint align="end">{{userCvv.value?.length || 0}}/3</mat-hint>

                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.cvv_login?.errors">
                                                    <div *ngIf="UF?.cvv_login?.errors?.required" class="help-box text-danger" style="font-size:12px;">CVV is required</div>
                                                    <div *ngIf="UF?.cvv_login?.errors?.minlength" class="help-box text-danger" style="font-size:12px;"> CVV must be at least 3 digit long.</div>
                                                </div>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                    <div class="row" *ngIf="CreditCardForm_login?.value.newCard_user">

                                        <div class="col-8" style="margin-top:10px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Street Address
                                            </mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" autocomplete="off" type="text" matInput #postalCode formControlName="street_address" style="border:none !important;" (keypress)="firstLaterCaps($event)">
                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.street_address?.errors">
                                                    <div *ngIf="UF?.street_address?.errors?.required" class="help-box text-danger" style="font-size:12px;">Street Address is required</div>
                                                </div>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-4" style="margin-top:10px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Apt/Suite #
                                            </mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" autocomplete="off" type="text" matInput #postalCode formControlName="apartment" style="border:none !important;" (keypress)="spaceNotAllowed($event)">

                                            </mat-form-field>
                                        </div>

                                        <div class="col-6" style="margin-top:10px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">City</mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" autocomplete="off" type="text" matInput #postalCode formControlName="city_address" style="border:none !important;" (keypress)="firstLaterCaps($event)">
                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.city_address?.errors">
                                                    <div *ngIf="UF?.city_address?.errors?.required" class="help-box text-danger" style="font-size:12px;">City is required</div>
                                                </div>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6" style="margin-top:13px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Province</mat-label>
                                            <mat-form-field style="display: contents;" appearance="outline">
                                                <select matNativeControl formControlName="state_address"  id="selectMonth">
                                                    <option [value]="null">Select</option>
                                                    <option *ngFor="let statelists of statelist" [value]="statelists.value">{{statelists.text}}</option>
                                                </select>
                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.state_address?.errors">
                                                    <div *ngIf="UF?.state_address?.errors?.required" class="help-box text-danger" style="font-size:12px;">Province is required</div>
                                                </div>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6" style="margin-top:10px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Country</mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" autocomplete="off" type="text" matInput #postalCode formControlName="country_address" style="border:none !important;" readonly>
                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.country_address?.errors">
                                                    <div *ngIf="UF?.country_address?.errors?.required" class="help-box text-danger" style="font-size:12px;">Country is required</div>
                                                </div>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6" style="margin-top:10px;" appearance="outline">
                                            <mat-label class="newLabelSize" style="font-size:14px;">Postal Code
                                            </mat-label>
                                            <mat-form-field style="display: contents;">
                                                <input class="newLabelSize" autocomplete="off" (keyup)="onKeyUp($event,'pcode_login')" (paste)="onPaste($event,'user')" type="text" matInput #postalCode maxlength="6" formControlName="pcode_login" style="border:none !important; text-transform: capitalize;" (keypress)="spaceNotAllowed($event)">
                                                <div class="form_placeholder" *ngIf="userCardSubmitted && UF?.pcode_login?.errors">
                                                    <div *ngIf="UF?.pcode_login?.errors?.required" class="help-box text-danger" style="font-size:12px;">Postal Code is required</div>
                                                    <div *ngIf="UF?.pcode_login?.errors?.minlength" class="help-box text-danger" style="font-size:12px;"> Postal Code must be at least 6 digit long.</div>
                                                </div>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div *ngIf="auth  && logincartProduct" class="product-list">
                            <ul class="cartDivScrollable">
                                <ng-container *ngFor="let product of logincartProduct['data']?.addtoCart">
                                    <li>
                                        <div class="row align-items-center left-right-marg">
                                            <div class="col-2">
                                                <a (click)="redirectToDetailPage(product.productslug)">
                                                    <img class="image_shop" [src]='product?.HeroShotUri?product?.HeroShotUri:defaultUrl'>
                                                </a>
                                            </div>
                                            <div class="col-5">
                                                <div class="product-name">{{product?.productName}}</div>
                                            </div>
                                            <div class="col-3">
                                                <div class='select-custom newSelectCustom'>
                                                    <p> {{product?.selectQuantity}}</p>
                                                </div>
                                            </div>
                                            <div class="col-2">
                                                <div class="product-price1">
                                                    <div class="price">
                                                        <div *ngIf="product.productType==='bundle'">
                                                            <ng-container *ngFor='let bundleOption of product.bundleOption'>
                                                                <span>{{bundleOption?.productName}} (1 Pack)</span>
                                                                <br>
                                                            </ng-container>
                                                        </div>
                                                        <span *ngIf="product.productType==='bundle'">{{product?.productTitle}}
                                                        </span>
                                                        <span class="newSpanSize" [class.margin-left-12]="product.productType==='simple'">{{product?.price | currency:'USD'}}</span>
                                                    </div>
                                                    <div *ngIf="product?.myPrice > product.price ">
                                                        <span class="discount-price">{{product.myPrice | currency:'USD'}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ng-container>
                            </ul>

                          
        
                            <form *ngIf="promoCodeForm" [formGroup]="promoCodeForm" >
                                <div class="row no-gutters promo-code">
                                    <div class="col">
                                        <input class="form-control" type="text" placeholder="Promo Code"  style="padding-inline-start:1vw; margin-bottom: 0px; height: 47px;" formControlName="promoCodeName">
                                        <div *ngIf="promosubmitted && pc.promoCodeName.errors">
                                            <div *ngIf="pc.promoCodeName.errors.required" class="help-box text-danger"
                                                style="font-size:12px;">
                                                Promo Code is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto" style="margin-left: 10px;">
                                        <button class="btn btn-lg btn-success" (click)="promoCodeFormSubmission(promoCodeForm.value)" *ngIf="!promoCodeAppilied" >Apply</button>
                                        <button class="btn btn-lg btn-danger" (click)="removePromoCode('removePromo')" *ngIf="promoCodeAppilied">Remove</button>
                                    </div>
                                </div>
                                <span *ngIf="promoCodeAppilied" style="color: #15d015;; font-size: 12px; font-weight: 600;">Promo Applied</span>
                                <div class="apply-promo" *ngIf="!promoCodeAppilied">
                                        <span>Select Promo</span>
                                    <div   class="promo-btn" *ngFor="let item of toyasPromos;let i=index">
                                        <a (click)="applyPromo(item)">{{item?.promoCodeName}}</a>
                                      </div>
                                </div>
                                
                            </form>
                            <!-- <div style="margin-top:5px;margin-bottom:5px;" *ngIf="promoCodeArray.length!==0">
                                <p style="font-weight: 700;color:#000;">Please select one of the following promo deals:</p>
                            </div>
                            <ng-container *ngFor="let code of promoCodeArray">
                                <div *ngIf='code.invalid == false' (click)="promoCodeApplyOnClick(code.promoCodeName)" class="promoCodeDivWidth" [class.activePromoCode]="code.promoCodeName===appliedPromoCode">
                                    {{code.promoCodeName}}
                                </div>
                                <div *ngIf='code.invalid == true' class="promoCodeDivWidthinavalid">
                                    {{code.promoCodeName}}
                                </div>
                            </ng-container> -->
                        </div>

                        <div class="cart-total-list">
                            <h3 class="check_text">Summary</h3>
                            <div class="right-tooltip">
                                <div class="hoverOnTooltip" *ngIf="auth" style="cursor:pointer; position: relative;">
                                    <span id="tooltip_new" class="tooltiptext">There is a maximun limit of 30g per
                                        order. Checkout will not be permitted if your order exceeds this limit</span>
                                    <h4 style="font-size: 14px;font-weight: 700;margin-right: 10px;display: inline-block;">
                                        {{getDigitwithoutzero(weightLimit)}}g / {{CartBarLimit}}g limit</h4>
                                    <img (click)="showToolTip()" src="assets/images/tooltipQues.png" style="width: 18px;height: 18px;cursor:pointer;display: inline-block;">
                                </div>
                                <div class="hoverOnTooltip" *ngIf="!auth" style="cursor:pointer;position: relative;">
                                    <span id="tooltip_new" class="tooltiptext">There is a maximun limit of 30g per
                                        order. Checkout will not be permitted if your order exceeds this limit</span>
                                    <h4 style="font-size: 14px;font-weight: 700;margin-right: 10px; display: inline-block;">
                                        {{getDigitwithoutzero(guestCartWeight)}} / {{CartBarLimit}}g limit</h4>
                                    <img (click)="showToolTip()" src="assets/images/tooltipQues.png" style="width: 18px;height: 18px;cursor:pointer;display: inline-block;">
                                </div>

                            </div>
                            <div class="row align-items-center">
                                <div class="col-9">

                                    <ul class="left-part check_text1">
                                        <li>Subtotal </li>
                                        <li>Tax</li>
                                        <li *ngIf="auth" [ngStyle]="{'line-height':promoCodeAppilied ?'20px':'37px'}">Discount
                                            <p *ngIf="promoCodeAppilied">
                                                <span *ngFor="let item of logincartProduct?.discountLabel" style="font-size: 11px; "><b>{{item}}</b> </span>
                                            </p>
                                        </li>

                                        <li *ngIf="optionType =='DELIVERY' && freeDelivery?.isdelivery">Delivery Charge</li>
                                        <li *ngIf="show_tip_in_cart && optionType =='DELIVERY'">Driver Tip</li>
                                        <li><b>Total</b></li>
                                    </ul>
                                </div>
                                <div *ngIf="auth" class='col-3'>
                                    <ul class="total-discount-bottom shopping_cart_price check_text1">
                                        <li>{{getSubTotal(logincartProduct?.subTotal) | currency:'USD'}}</li>
                                        <li>{{logincartProduct?.tax | currency:'USD'}}</li>
                                        <li *ngIf="auth" [ngStyle]="{'line-height':promoCodeAppilied ?'35px':'40px'}">{{cartProduct?.discount | currency:'USD'}}</li>

                                        <li *ngIf="freeDelivery?.isdelivery && optionType =='DELIVERY'">
                                            <span *ngIf="getSubTotal(logincartProduct?.subTotal) >= freeDelivery?.freeDeliveryAmount">
                                                <span style="text-decoration: line-through;">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span> FREE
                                            </span>
                                            <span *ngIf="getSubTotal(logincartProduct?.subTotal) < freeDelivery?.freeDeliveryAmount">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span>
                                        </li>
                                        <li *ngIf="show_tip_in_cart && optionType =='DELIVERY'">{{(driver_tip?driver_tip:0) | currency:'USD'}}</li>
                                        <li>{{getFinalDisc_authCase(logincartProduct?.grandTotal)| currency:'USD'}}
                                        </li>
                                    </ul>
                                </div>
                                <div *ngIf="!auth" class="col-3">
                                    <ul class="right-part">
                                        <li><span class="">{{getOffineCartAmount() | currency:'USD'}} </span></li>
                                        <span>{{guestTax | currency:'USD'}}</span>
                                        <li *ngIf="freeDelivery?.isdelivery && optionType =='DELIVERY'">
                                            <span *ngIf="getOffineCartAmount() >= freeDelivery?.freeDeliveryAmount">
                                                <span style="text-decoration: line-through;">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span> FREE
                                            </span>
                                            <span *ngIf="getOffineCartAmount() < freeDelivery?.freeDeliveryAmount">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span>
                                        </li>
                                        <li *ngIf=" show_tip_in_cart">{{(driver_tip?driver_tip:0) | currency:'USD'}}</li>

                                        <li><span style="font-weight:bold !important;">
                                                {{guestGTotal | currency:'USD'}}
                                            </span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <a (click)="PlaceOrderforLoginUser()" class="shadow1 proceed-to-checkouts cursor">Place
                            order</a>
                        <a (click)="backFrom_Proceed_checkout_auth()" class="GO_BACK cursor"> <img src="assets/images/left-arrow.png" alt=""> Go Back</a>



                    </div>




                </div>
                <div *ngIf="step==4" class="cart-checkout">
                    <div *ngIf="guestdilveryShow == 'false' && optionType =='DELIVERY'">
                        <h4>Tip your driver</h4>
                        <div class="tip_driver">
                            <input (click)="calucalte_driverTip(10)" type="radio" class="btn-tip" id="10" name="tips" />
                            <label for="10">10%</label>
                            <input (click)="calucalte_driverTip(15)" type="radio" class="btn-tip" id="15" name="tips" />
                            <label for="15">15%</label>
                            <input (click)="calucalte_driverTip(20)" type="radio" class="btn-tip" id="20" name="tips" />
                            <label for="20">20%</label>
                            <input (click)="calucalte_driverTip(25)" type="radio" class="btn-tip" id="25" name="tips" />
                            <label for="25">25%</label>
                            <input (click)="calucalte_driverTip(30)" type="radio" class="btn-tip" id="30" name="tips" />
                            <label for="30">30%</label>
                            <div class="flex">
                                <input id="custom_tip" (keyup)="driverCustomTip($event)" name="customTip" placeholder="Dollar Amount">

                                <button *ngIf="!show_tip_in_cart " (click)="applytip(true)" class="btn btn-primary" style="min-width:100px !important; height:43px;border-radius: 10px;">Apply
                                    Tip</button>
                                <button *ngIf="show_tip_in_cart" (click)="applytip(false)" class="btn btn-primary" style="min-width:100px !important; height:43px;border-radius: 10px;">Remove
                                    Tip</button>
                            </div>

                        </div>
                    </div>
                    <p style="color: red;font-size: 10px;" *ngIf="invalidTip">You must enter a valid tip</p>

                    <h4 *ngIf="!canShowThankyoupage">Product Details</h4>
                    <h4 *ngIf="canShowThankyoupage">Your Order</h4>
                    <div *ngIf="auth  && logincartProduct" class="product-list">
                        <ul class="cartDivScrollable">
                            <ng-container *ngFor="let product of logincartProduct['data']?.addtoCart">
                                <li>
                                    <div class="row align-items-center left-right-marg">
                                        <div class="col-2">
                                            <a (click)="redirectToDetailPage(product.productslug)">
                                                <img class="image_shop" [src]='product?.HeroShotUri?product?.HeroShotUri:defaultUrl'>
                                            </a>
                                        </div>
                                        <div class="col-5">
                                            <div class="product-name">{{product?.productName}}</div>
                                        </div>
                                        <div class="col-3">
                                            <div class='select-custom newSelectCustom'>
                                                <p> {{product?.selectQuantity}}</p>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="product-price1">
                                                <div class="price">
                                                    <div *ngIf="product.productType==='bundle'">
                                                        <ng-container *ngFor='let bundleOption of product.bundleOption'>
                                                            <span>{{bundleOption?.productName}} (1 Pack)</span>
                                                            <br>
                                                        </ng-container>
                                                    </div>
                                                    <span *ngIf="product.productType==='bundle'">{{product?.productTitle}}
                                                    </span>
                                                    <span class="newSpanSize" [class.margin-left-12]="product.productType==='simple'">{{product?.price | currency:'USD'}}</span>
                                                </div>
                                                <div *ngIf="product?.myPrice > product.price ">
                                                    <span class="discount-price">{{product.myPrice | currency:'USD'}}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                    <div *ngIf="!auth" class="product-list">
                        <ul class="cartDivScrollable">
                            <ng-container *ngFor="let product of offlineCartProduct">
                                <li>
                                    <div class="row align-items-center left-right-marg">
                                        <div class="col-2">
                                            <a class="image_shop" (click)="redirectToDetailPage(product.productslug)">
                                                <img [src]='product.productImg'>
                                            </a>

                                        </div>
                                        <div class="col-5">
                                            <div class="product-name">{{product.productName}} </div>
                                        </div>
                                        <div class="col-3">
                                            <div>
                                                <div class='select-custom'>
                                                    <p> {{product?.quantity}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="product-price1">
                                                <div class="price">
                                                    <div *ngIf="product.productType==='bundle'">
                                                        <ng-container *ngFor='let bundleOption of product.bundleOption'>
                                                            <span>{{bundleOption.productName}} (1 Pack)</span>
                                                            <br>
                                                        </ng-container>
                                                    </div>
                                                    <span *ngIf="product.productType==='bundle'">{{product.productTitle}}</span>
                                                    <span class="newSpanSize" [class.margin-left-12]="product.productType==='simple'">{{product.price | currency:'USD'}}</span>
                                                    <div *ngIf="product?.myPrice > product.price ">
                                                        <span class="discount-price">{{product.myPrice | currency:'USD'}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ng-container>
                        </ul>
                    </div>


                    <div class="cart-total-list">
                        <h3 class="check_text">Summary</h3>
                        <div class="right-tooltip">
                            <div class="hoverOnTooltip" *ngIf="auth" style="cursor:pointer; position: relative;">
                                <span id="tooltip_new" class="tooltiptext">There is a maximun limit of 30g per
                                    order. Checkout will not be permitted if your order exceeds this limit</span>
                                <h4 style="font-size: 14px;font-weight: 700;margin-right: 10px;display: inline-block;">
                                    {{getDigitwithoutzero(weightLimit)}}g / {{CartBarLimit}}g limit</h4>
                                <img (click)="showToolTip()" src="assets/images/tooltipQues.png" style="width: 18px;height: 18px;cursor:pointer;display: inline-block;">
                            </div>
                            <div class="hoverOnTooltip" *ngIf="!auth" style="cursor:pointer;position: relative;">
                                <span id="tooltip_new" class="tooltiptext">There is a maximun limit of 30g per
                                    order. Checkout will not be permitted if your order exceeds this limit</span>
                                <h4 style="font-size: 14px;font-weight: 700;margin-right: 10px; display: inline-block;">
                                    {{getDigitwithoutzero(guestCartWeight)}} / {{CartBarLimit}}g limit</h4>
                                <img (click)="showToolTip()" src="assets/images/tooltipQues.png" style="width: 18px;height: 18px;cursor:pointer;display: inline-block;">
                            </div>

                        </div>
                        <div class="row align-items-center">
                            <div class="col-9">

                                <ul class="left-part check_text1">
                                    <li>Subtotal </li>
                                    <li>Tax</li>
                                    <li *ngIf="optionType =='DELIVERY' && freeDelivery?.isdelivery ">Delivery Charge</li>
                                    <li *ngIf="show_tip_in_cart && optionType =='DELIVERY'">Driver Tip</li>
                                    <li><b>Total</b></li>
                                </ul>
                            </div>
                            <div *ngIf="auth" class='col-3'>
                                <ul class="total-discount-bottom shopping_cart_price check_text1">
                                    <li>{{getSubTotal(logincartProduct?.subTotal) | currency:'USD'}}</li>
                                    <li>{{logincartProduct?.tax | currency:'USD'}}</li>
                                    <li *ngIf="freeDelivery?.isdelivery && optionType =='DELIVERY'">
                                        <span *ngIf="getSubTotal(logincartProduct?.subTotal) >= freeDelivery?.freeDeliveryAmount">
                                            <span style="text-decoration: line-through;">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span> FREE
                                        </span>
                                        <span *ngIf="getSubTotal(logincartProduct?.subTotal) < freeDelivery?.freeDeliveryAmount">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span>
                                    </li>
                                    <li *ngIf="show_tip_in_cart && optionType =='DELIVERY'">{{(driver_tip ? driver_tip:0)| currency:'USD'}}</li>
                                    <li>{{getFinalDisc_authCase(logincartProduct?.grandTotal) | currency:'USD'}}
                                    </li>
                                </ul>
                            </div>
                            <div *ngIf="!auth" class="col-3">
                                <ul class="right-part">
                                    <li><span class="">{{getOffineCartAmount()| currency:'USD'}} </span></li>
                                    <span>{{guestTax | currency:'USD'}}</span>
                                    <li *ngIf="freeDelivery?.isdelivery && optionType =='DELIVERY'">
                                        <span *ngIf="getOffineCartAmount() >= freeDelivery?.freeDeliveryAmount">
                                            <span style="text-decoration: line-through;">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span> FREE
                                        </span>
                                        <span *ngIf="getOffineCartAmount() < freeDelivery?.freeDeliveryAmount">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span>
                                    </li>
                                    <li *ngIf=" show_tip_in_cart">{{(driver_tip ? driver_tip:0) | currency:'USD'}}</li>
                                    <li><span style="font-weight:bold !important;">
                                            {{getFinalDisc_guestCase(guestGTotal) | currency:'USD'}}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <a *ngIf="!auth" (click)="guestOrderPlace()" class="shadow1 proceed-to-checkouts cursor">Place
                        order</a>
                    <a *ngIf="auth" (click)="PlaceOrderforLoginUser()" class="shadow1 proceed-to-checkouts cursor">Place
                        order</a>
                    <a *ngIf="auth" (click)="backFrom_Proceed_checkout_auths()" class="GO_BACK cursor"> <img src="assets/images/left-arrow.png" alt=""> Go Back</a>
                    <a *ngIf="!auth" (click)="backFrom_Guest_t()" class="GO_BACK cursor">
                        <img src="assets/images/left-arrow.png" alt=""> Go Back</a>

                </div>

                <div *ngIf="step==5" class="cart-checkout">

                    <p *ngIf="canShowThankyoupage" class="message_cart" style="font-weight: bold;color: black;font-size: 17px; margin-top: 10px;">
                        {{thankyoupageType2}} </p>
                    <ul *ngIf="canShowThankyoupage" style="margin-top: 10px;">
                        <ng-container>
                            <li>
                                <div class="">
                                    <div class="product-name"><strong> Order ID </strong>-
                                        {{orderDetail?.orderDisplayId}} </div>
                                </div>
                            </li>
                            <li>
                                <div class="">
                                    <div class="product-name"><strong>Date </strong>- {{orderDetail?.orderDate | date}} </div>
                                </div>
                            </li>
                            <li>
                                <div class="">
                                    <div class="product-name"><strong>Email </strong>- {{orderDetail?.userEmailId}}
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="">
                                    <div class="product-name"><strong>Time Slot</strong> - {{orderDetail?.deliveryTimeSlot}} </div>
                                </div>
                            </li>
                            <li>
                                <div class="" *ngIf="orderDetail?.paymentMethod == 'creditcard'">
                                    <div class="product-name" style="text-transform: capitalize;"><strong>Payment Method</strong> - Credit Card </div>
                                </div>
                            </li>
                            <li *ngIf="canShowPaymentStatus">
                                <div class="">
                                    <div class="product-name" style="text-transform: capitalize;"><strong>Payment Status</strong> - {{pamyentStatus}} </div>
                                </div>
                            </li>
                            <li *ngIf="(pamyentStatus != 'Pending' && canShowPaymentStatus)">
                                <div class="">
                                    <div class="product-name" style="text-transform: capitalize;"><strong>Payment Message</strong> - {{paymentMessage}} </div>
                                </div>
                            </li>
                            <li style="background-color: antiquewhite;" *ngIf="pamyentStatus == 'Failed' && selectedPaymentMethod_auth =='creditcard'">
                                <div class="">
                                    <div class="rapayment-info" style="text-transform: capitalize;">
                                        We apologize, but we could not complete your transaction. Please re-submit your credit card information, ensuring that the card number is entered correctly. Alternatively, you may use a different credit card. Thank you.
                                        <button (click)="backToCreditCard()" class="btn btn-primary re-try">Re-Payment</button>
                                    </div>
                                </div>
                            </li>
                        </ng-container>
                    </ul>

                    <h4 *ngIf="!canShowThankyoupage">Product Details</h4>
                    <h4 *ngIf="canShowThankyoupage">Your Order</h4>
                    <div *ngIf="auth  && logincartProduct" class="product-list">
                        <ul class="cartDivScrollable">
                            <ng-container *ngFor="let product of logincartProduct['data']?.addtoCart">
                                <li>
                                    <div class="row align-items-center left-right-marg">
                                        <div class="col-2">
                                            <a (click)="redirectToDetailPage(product?.productslug)">
                                                <img class="image_shop" [src]='product?.HeroShotUri?product?.HeroShotUri:defaultUrl'>
                                            </a>
                                        </div>
                                        <div class="col-5">
                                            <div class="product-name">{{product?.productName}}</div>
                                        </div>
                                        <div class="col-3">
                                            <div class='select-custom newSelectCustom'>
                                                <p> {{product?.selectQuantity}}</p>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="product-price1">
                                                <div class="price">
                                                    <div *ngIf="product.productType==='bundle'">
                                                        <ng-container *ngFor='let bundleOption of product.bundleOption'>
                                                            <span>{{bundleOption?.productName}} (1 Pack)</span>
                                                            <br>
                                                        </ng-container>
                                                    </div>
                                                    <span *ngIf="product?.productType==='bundle'">{{product?.productTitle}}
                                                    </span>
                                                    <span class="newSpanSize" [class.margin-left-12]="product?.productType==='simple'">{{product?.price | currency:'USD'}}</span>
                                                </div>
                                                <div *ngIf="product?.myPrice > product.price ">
                                                    <span class="discount-price">{{product.myPrice | currency:'USD'}}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                    <div *ngIf="!auth" class="product-list">
                        <ul class="cartDivScrollable">
                            <ng-container *ngFor="let product of offlineCartProduct">
                                <li>
                                    <div class="row align-items-center left-right-marg">
                                        <div class="col-2">
                                            <a class="image_shop" (click)="redirectToDetailPage(product.productslug)">
                                                <img [src]='product.productImg'>
                                            </a>

                                        </div>
                                        <div class="col-5">
                                            <div class="product-name">{{product.productName}} </div>
                                        </div>
                                        <div class="col-3">
                                            <div>
                                                <div class='select-custom'>
                                                    <p> {{product?.quantity}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="product-price1">
                                                <div class="price">
                                                    <div *ngIf="product.productType==='bundle'">
                                                        <ng-container *ngFor='let bundleOption of product.bundleOption'>
                                                            <span>{{bundleOption.productName}} (1 Pack)</span>
                                                            <br>
                                                        </ng-container>
                                                    </div>
                                                    <span *ngIf="product.productType==='bundle'">{{product.productTitle}}</span>
                                                    <span class="newSpanSize" [class.margin-left-12]="product.productType==='simple'">{{product.price | currency:'USD'}}</span>
                                                    <div *ngIf="product?.myPrice > product.price ">
                                                        <span class="discount-price">{{product.myPrice | currency:'USD'}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                    <div class="cart-total-list">
                        <h3 class="check_text">Summary</h3>
                        <!-- <div class="right-tooltip">
                                <div class="hoverOnTooltip" *ngIf="auth" style="cursor:pointer; position: relative;">
                                    <span id="tooltip_new" class="tooltiptext">There is a maximun limit of 30g per
                                        order. Checkout will not be permitted if your order exceeds this limit</span>
                                    <h4
                                        style="font-size: 14px;font-weight: 700;margin-right: 10px;display: inline-block;">
                                        {{getDigitwithoutzero(weightLimit)}}g / {{CartBarLimit}}g limit</h4>
                                    <img (click)="showToolTip()" src="assets/images/tooltipQues.png"
                                        style="width: 18px;height: 18px;cursor:pointer;display: inline-block;">
                                </div>
                                <div class="hoverOnTooltip" *ngIf="!auth" style="cursor:pointer;position: relative;">
                                    <span id="tooltip_new" class="tooltiptext">There is a maximun limit of 30g per
                                        order. Checkout will not be permitted if your order exceeds this limit</span>
                                    <h4
                                        style="font-size: 14px;font-weight: 700;margin-right: 10px; display: inline-block;">
                                        {{getDigitwithoutzero(guestCartWeight)}} / {{CartBarLimit}}g limit</h4>
                                    <img (click)="showToolTip()" src="assets/images/tooltipQues.png"
                                        style="width: 18px;height: 18px;cursor:pointer;display: inline-block;">
                                </div>

                            </div> -->
                        <div class="row align-items-center">
                            <div class="col-9">
                                <ul class="left-part check_text1">
                                    <li>Subtotal </li>

                                    <li>Tax</li>
                                    <li *ngIf="auth" [ngStyle]="{'line-height':promoCodeAppilied ?'20px':'37px'}"><b>Discount  </b><br>
                                        <p *ngIf="promoCodeAppilied">
                                            <span *ngFor="let item of logincartProduct?.discountLabel" style="font-size: 11px;"><b>{{item}}</b></span>
                                        </p>
                                    </li>
                                    <li *ngIf="optionType =='DELIVERY' && freeDelivery?.isdelivery">Delivery Charge</li>

                                    <li *ngIf="show_tip_in_cart && optionType =='DELIVERY'">Driver Tip</li>

                                    <!-- <li>Savings</li> -->

                                    <li><b>Total</b></li>
                                </ul>
                            </div>
                            <div *ngIf="auth" class='col-3'>
                                <ul class="total-discount-bottom shopping_cart_price check_text1">
                                    <li>{{getSubTotal(logincartProduct?.subTotal) | currency:'USD'}}</li>

                                    <li>{{logincartProduct?.tax | currency:'USD'}}</li>

                                    <li *ngIf="auth" [ngStyle]="{'line-height':promoCodeAppilied ?'35px':'40px'}">{{logincartProduct?.discount | currency:'USD'}}</li>

                                    <li *ngIf="freeDelivery?.isdelivery && optionType =='DELIVERY'">
                                        <span *ngIf="getSubTotal(logincartProduct?.subTotal) >= freeDelivery?.freeDeliveryAmount">
                                            <span style="text-decoration: line-through;">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span> FREE
                                        </span>
                                        <span *ngIf="getSubTotal(logincartProduct?.subTotal) < freeDelivery?.freeDeliveryAmount">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span>
                                    </li>
                                    <li *ngIf="show_tip_in_cart && optionType =='DELIVERY'">{{(driver_tip?driver_tip:0) | currency:'USD'}}</li>
                                    <li>{{getFinalDisc_authCase(logincartProduct?.grandTotal)| currency:'USD'}}
                                    </li>
                                </ul>
                            </div>
                            <div *ngIf="!auth" class="col-3">
                                <ul class="right-part">
                                    <li><span class="">{{getOffineCartAmount()| currency:'USD'}} </span></li>
                                    <span>{{guestTax | currency:'USD'}}</span>
                                    <li *ngIf="freeDelivery?.isdelivery && optionType =='DELIVERY'">
                                        <span *ngIf="getOffineCartAmount() >= freeDelivery?.freeDeliveryAmount">
                                            <span style="text-decoration: line-through;">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span> FREE
                                        </span>
                                        <span *ngIf="getOffineCartAmount() < freeDelivery?.freeDeliveryAmount">{{freeDelivery?.deliveryCharges | currency:'USD'}}</span>
                                    </li>
                                    <li *ngIf=" show_tip_in_cart">{{(driver_tip?driver_tip:0) | currency:'USD'}}</li>

                                    <li><span style="font-weight:bold !important;">
                                            {{getFinalDisc_guestCase(guestGTotal) | currency:'USD'}}
                                        </span></li>
                                </ul>
                            </div>
                        </div>
                    </div>



                    <a (click)="hidecart()" class="shadow1 proceed-to-checkout cursor ng-star-inserted">Continue Shopping</a>

                </div>

            </div>
        </div>
    </div>
</div>









<div class="modal search-location modalBackgroundNone firstpopuponload where-are-you Pick_Up_Store_new New_all_store_location_list" id="SearchLocation" style="background: url(https://www.localcannabisco.ca/assets/images/bg1.jpg);">
    <div class="modal-dialog">
        <div class="modal-content" style='background: transparent!important;'>
            <div class="modal-body" style="padding: 0 !important;">

                <div class="Location_checkout">
                    <div class="Checkout_logo">
                        <img src="{{siteDada?.footerLogo?.url}}">
                        <h2>{{siteDada?.storePageTitle}}</h2>
                        <h3>{{siteDada?.storePageDescription}}</h3>
                    </div>
                    <div class="All-Location_List">
                        <div class="row justify-content-center">
                            <ng-container *ngFor=" let list of pickUpStoreList;let k=index">
                                <div class="col-md-4">
                                    <div class="Location_list">
                                        <h4>
                                            {{list?.Name}}
                                            <a (click)="storeOpenCloseTimeingnew(list?.Name,list)">
                                                <img src="assets/images/about-icon-23.png" width="20px">
                                            </a>
                                        </h4>
                                        <figure>
                                            <img class="location-store-img" src="{{list?.image}}" (click)="updatePickUpStoreData(list?.Id, list?.Name,  list?.storeAccountNum, list?.authorization,  list.Address.AddressLine1, list.Address.AddressLine2, list.Address.City, list.Address.StateName, list.Address.StateCode, list.Address.CountryName, list.Address.CountryCode, list.Address.Zip, list?.storeLocation, list?.coordinates[0], list?.coordinates[1],true,'true','true')">
                                        </figure>
                                        <a class="Site_product_list" (click)="updatePickUpStoreData(list?.Id, list?.Name, list?.storeAccountNum, list?.authorization, list.Address.AddressLine1, list.Address.AddressLine2, list.Address.City, list.Address.StateName, list.Address.StateCode, list.Address.CountryName, list.Address.CountryCode, list.Address.Zip, list?.storeLocation, list?.coordinates[0], list?.coordinates[1],true,'true','true')">
                                            menu
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- pop up for header /can be in sidenav too-->
    <div id="popup1information" class="overlay1information">
        <div class="popup1information">
            <a class="close" href="#">&times;</a>
            <div class="content_pop">
                <p>Delivery Available!</p>
                <p><b>Please read details below before ordering.</b></p>
                <p>Important Details for Delivery</p>
                <p><b>Cut-Off for Same Day Delivery: 3:00pm</b></p>
                <p><b>Delivery Window: 3:00pm to 5:00pm</b></p>
                <p>When your Delivery Driver has left the store with your order, you will receive a text message
                    confirming they are on the way. The delivery will <b>arrive between 3:00pm and 5:00pm.</b></p>
                <p>Please meet your delivery driver at the front door of provided address with your ID. All deliveries
                    must be signed for by an individual 19 years of age or older.</p>
                <p>If there are any specific instructions or steps needed for your driver to get to your front door,
                    please provide in the "Special Instructions" section when completing your order. </p>
                <p><b>DELIVERY IS ONLY AVAILABLE FOR PRE-PAID ORDERS AT CHECKOUT.</b></p>
                <p>Proudly serving the Parksville, French Creek, Errington, Coombs, Qualicum, Nanoose Bay and Lantzville
                    regions.</p>
                <p>Delivery Minimums:</p>
                <p>Parksville/French Creek ($25)</p>
                <p>Nanoose Bay/Qualicum Beach/Coombs/Errington ($50)</p>
                <p>Lantzville ($100)</p>
                <p>Delivery Fees</p>
                <p> $0 for orders of $75 or greater</p>
                <p>$5 for orders less than $75</p>
                <p>All Sales are Final. No Refunds unless provincially recalled Delivery Available Now! Please read
                    details below before ordering. </p>
            </div>
        </div>
    </div>
</div>



<div class="modal search-location modalBackgroundNone firstpopuponload where-are-you" id="SearchLocation1">
    <div class="modal-dialog">
        <div class="modal-content newContentCSS" style='background: transparent!important;'>
            <div class="modal-header">
                <button type="button" *ngIf="hideCloseBtn" class="close" data-dismiss="modal" (click)="searchCloseBtnClick()" style='color:#fff;'>
                    <i class="fa fa-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="location">
                    <h2>Where do you want your Delivery?</h2>
                    <p style="padding-bottom: 18px;"></p>
                    <p class="location-box" style="text-align: left;">
                        <img src="assets/images/location-2.png" alt="">
                        <!-- <input ngx-google-places-autocomplete id="searchAddressInput" value="{{addressString}}"
                            placeholder="Enter your location here" #placesRef="ngx-places" [options]="{
                            types: [],
                            componentRestrictions: { country: ['CA','USA'] }
                            }" (onAddressChange)="handleAddressChangeDelivery($event)"
                            class="form-control form-control-borderless" /> -->
                        <input type="text" (keyup)="getAddresss($event)" (click)="addressField =true" class="form-control" [(ngModel)]="addressString" [ngModelOptions]="{standalone: true}" name="" placeholder="Enter Your Delivery Address">
                        <ng-container *ngIf="addressField && tomaddressData?.length>0">
                            <div id="DivOut" class="address-sug">
                                <ul style="list-style: none;">
                                    <li class="searchinheader" *ngFor="let item of tomaddressData" style="display: flex;align-items: center;">
                                        <a class="text_mobile_search" (click)="chooseAddressForMapBox(item)"> <i class="fa fa-map-marker"></i> {{item?.place_name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                    </p>
                    <div class="Pick_Up_Store_scroll">

                        <div class="Pick_Up_Store_location new_store_listing">
                            <div class="row PickUPnewClass">
                                <ng-container *ngFor=" let list of pickupStoreListInThisRegion;let k=index">
                                    <div class="col-6" style="margin: auto;">
                                        <img src="{{list?.image}}" class="location-store-img">
                                        <span style="display: inline-block;">
                                            {{list.Address.AddressLine1 + ' ' + list.Address.City }}
                                        </span>
                                        <button (click)="callDeliveryStoreSelected(k)" class="popupButton" [class.activeButton]="true">Select </button>

                                    </div>
                                </ng-container>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Logout Pop Up-->
<div class="modal search-location modalBackgroundNone firstpopuponload3 where-are-you" id="logoutPopUp" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content" style='background: transparent!important;'>
            <div class="modal-body  logoutPopupWidth">
                <h5>Are you sure to Logout?</h5>
                <div class="location" style="padding:0">

                    <div class="row">
                        <div class="col-md-6">
                            <button (click)="hideLogoutPopUp()" class="popupButton" style="width: 100%;">No</button>
                        </div>
                        <div class="col-md-6">
                            <button (click)="logout()" class="popupButton" style="  width: 100%;  background: #000;
                        color: #fff;">Logout</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Mobile Popup-->
<div class=" modal get-verify-number-popup mobilePopUp" id="mobileVerifyPopup" style="background: url(assets/images/bg1.jpg);">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="get-verify">
                    <h2>Verify your phone</h2>
                    <img src="assets/images/phone.png">
                    <p>To complete Releaf sign up, you need to verify your phone number.</p>
                    <a href="javascript:;" (click)="redirectToMobileVerifyPage()" class="get-verified">Get verified</a>
                    <a href="javascript:;" (click)="logout()" class="another-account">Sign in as another user</a>
                </div>
            </div>
        </div>
    </div>
</div>




<!-- <div class="modal fade" id="viewPromoPoup" tabindex="-1" aria-labelledby="footerInfoIdLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="footerInfoIdLabel">Promos</h5>
                <button type="button" class="close" (click)="hideApkModal()" aria-label="Close">
                    <span aria-hidden="true" style="font-size: 30px;">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="padding:15px;">
              <div class="promo-list" *ngFor="let item of toyasPromos;let i=index">
                <input type="checkbox" id="promo{{i}}" name="promo{{i}}" value="Bike">
                <label for="promo{{i}}">{{item?.promoCodeName}}</label><br>
              </div>

            </div>
           
        </div>
    </div>
</div> -->



<div class=" modal get-verify-number-popup mobilePopUp" id="storeHistoryModal" style="background: url(assets/images/bg1.jpg); background: rgba(0,0,0,0.8) !important;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="herader_location_overlay">
                    <div class="herader_location_popup">
                        <a *ngIf="pickUpStoreList?.length > 1" (click)="selectMailOrderFromHeader('true')" class="newButton" style="display: inline-block;">
                            Switch Location
                        </a>
                        <a style="margin-top: 10px;" (click)="storeOpenCloseTimeing(selectedStoreName)" class="mobile_about_imfo">
                            <img src="assets/images/about-icon-23.png" width="24px"></a>


                        <img src="{{storeImage}}" alt="{{selectedStoreName}}" style="border-radius: 0px;margin-bottom: 15px;
                        width: 100%;">

                        <div>
                            <h2>{{selectedStoreName}}
                                <span class="store_open" *ngIf="!StoreClosed">Open</span>
                                <span class="store_close" *ngIf="StoreClosed">Closed</span>
                                <a class="mobile_about_mobile" style="cursor: pointer;margin-top: 8px;margin-left: 5px;" [href]="'tel:'+getStoreMObile()"><i style="font-size: 24px;" class="fa fa-phone"></i></a>
                            </h2>
                        </div>
                        <p class="loc-adddress-home">
                            <img src="assets/images/place.png" width="24px" class="loca-img-new">

                            <a href="http://maps.google.com/?q={{addressValue(storeAddress)}}" target="_blank"> <img style="cursor:pointer;" alt="">{{addressValue(storeAddress)}}
                            </a>
                        </p>
                        <!-- modal near logo -->
                        <!-- header section (i)icon  -->
                        <h4 style="display:flex; align-items: center;">
                            <span class="desktop-Visible">
                                Service Options
                                <a style="margin-left: 10px;" (click)="storeOpenCloseTimeing(selectedStoreName)" class="tablat_about_imfo">
                                    <img src="assets/images/about-icon-23.png" width="24px"></a>
                                <a class="tablat_about_mobile" [href]="'tel:'+getStoreMObile()"><i style="font-size: 24px;" class="fa fa-phone"></i></a>
                            </span>
                        </h4>
                        <p style="font-size: 16px " id="newIdgivenNow">{{manageOrderOptions('Delivery')}}{{manageOrderOptions('Pickup')}}{{manageOrderOptions('CurbsidePickup')}}<br>
                            <b style="font-size: 13px ;" class="stylePop">
                                <span *ngIf="manageStoreTIme('Pickup')"> In-Store
                                    {{newStoreHoursFormat(this.storeTime?.Open?.Hour,this.storeTime?.Open?.Minute)}} -
                                    {{newStoreHoursFormat(this.storeTime?.Close?.Hour,this.storeTime?.Close?.Minute)}}</span>
                                <br>
                                <span *ngIf="manageStoreTIme('Delivery')">
                                    Delivery
                                    {{newStoreHoursFormat(this.dilverytime?.Open?.Hour,this.dilverytime?.Open?.Minute)}} -
                                    {{newStoreHoursFormat(this.dilverytime?.Close?.Hour,this.dilverytime?.Close?.Minute)}}</span>

                            </b>
                        </p>

                        <a class="herader_location_popup_close" (click)="modalClose()"><i class="fa fa-close"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal mobilePopUp" id="storeOpenCloseTimeing" style="background: url(assets/images/bg1.jpg); background: rgba(0,0,0,0.8) !important;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="herader_location_overlay newPara_dynamic">
                    <ng-container *ngFor="let list of pickUpStoreList">
                        <div *ngIf="list.Name == selectedStoreName">
                            <p innerHtml="
                                {{list?.storeInfo}}"></p>

                            <a class="herader_location_popup_close" (click)="storeOpenCloseTimeing1()"><i class="fa fa-close"></i></a>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<!--store-->
<div class="modal mobilePopUp " id="storeOpenCloseTimeing2" style="z-index:99999 !important ;">
    <div class="modal-dialog new-Height" style="height: 100%;">
        <div class="modal-content new-Height" style="height: 100%; margin:10px;">
            <div class="modal-body">
                <p *ngIf="showLoading">Loading ...</p>
                <div class="herader_location_overlay" *ngIf="!showLoading">
                    <h2>STORE HOURS</h2>
                    <div class="week-days">

                        <input *ngIf="manageOrderOption('Pickup')" id="tab1" type="radio" name="tabs" checked>
                        <label *ngIf="manageOrderOption('Pickup')" for="tab1">Pickup</label>


                        <input *ngIf="manageOrderOption('CurbsidePickup')" id="tab3" type="radio" name="tabs">
                        <label *ngIf="manageOrderOption('CurbsidePickup')" for="tab3">Curbside</label>


                        <input *ngIf="manageOrderOption('Delivery')" id="tab2" type="radio" name="tabs">
                        <label *ngIf="manageOrderOption('Delivery')" for="tab2">Delivery</label>



                        <div *ngIf="manageOrderOption('Delivery')" class="content" id="content2">
                            <div class="row">
                                <div class="col-4"><span>Sunday: </span></div>
                                <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Sunday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Sunday?.Open?.Hour,CurrentStoreData?.DeliveryHours?.Sunday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Sunday?.Close?.Hour,CurrentStoreData?.DeliveryHours?.Sunday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Sunday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Monday: </span></div>
                                <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Monday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Monday?.Open?.Hour,CurrentStoreData?.DeliveryHours?.Monday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Monday?.Close?.Hour,CurrentStoreData?.DeliveryHours?.Monday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Monday?.isOpen">
                                    Closed
                                </div>


                            </div>
                            <div class="row">
                                <div class="col-4"><span>Tuesday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Tuesday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Tuesday?.Open?.Hour,CurrentStoreData?.DeliveryHours?.Tuesday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Tuesday?.Close?.Hour,CurrentStoreData?.DeliveryHours?.Tuesday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Tuesday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Wednesday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Wednesday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Wednesday?.Open?.Hour,CurrentStoreData?.DeliveryHours?.Wednesday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Wednesday?.Close?.Hour,CurrentStoreData?.DeliveryHours?.Wednesday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Wednesday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Thursday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Thursday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Thursday?.Open?.Hour,CurrentStoreData?.DeliveryHours?.Thursday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Thursday?.Close?.Hour,CurrentStoreData?.DeliveryHours?.Thursday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Thursday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Friday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Friday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Friday?.Open?.Hour,CurrentStoreData?.DeliveryHours?.Friday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Friday?.Close?.Hour,CurrentStoreData?.DeliveryHours?.Friday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Friday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Saturday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Saturday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Saturday?.Open?.Hour,CurrentStoreData?.DeliveryHours?.Saturday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Saturday?.Close?.Hour,CurrentStoreData?.DeliveryHours?.Saturday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Saturday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="box">
                                        <img src="{{storeImage}}" alt="{{selectedStoreName}}" style="border-radius: 0px;margin-bottom: 15px; width: 100%;">

                                        <div style="display: flex;padding: 5px;">
                                            <h3 style="font-size: 16px;">You're shopping at <strong>
                                                    {{selectedStoreName}}</strong></h3>
                                            <div class="newForthis">
                                                <span class="store_open" *ngIf="!StoreClosed">Open</span>
                                                <span class="store_close" *ngIf="StoreClosed">Closed</span>
                                            </div>
                                        </div>
                                        <p class="loc-adddress-home" style="padding: 5px;">
                                            <img src="assets/images/place.png" width="24px" class="loca-img-new">

                                            <a style="font-size: 13px;" href="http://maps.google.com/?q={{storeAddresss}}" target="_blank">
                                                <img style="cursor:pointer;" alt="">{{storeAddresss}}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="manageOrderOption('CurbsidePickup')" class="content" id="content3">
                            <div class="row">
                                <div class="col-4"><span>Sunday: </span></div>
                                <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Sunday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Sunday?.Open?.Hour,CurrentStoreData?.CurbsideHours?.Sunday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Sunday?.Close?.Hour,CurrentStoreData?.CurbsideHours?.Sunday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Sunday?.isOpen">
                                    Closed
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4"><span>Monday: </span></div>


                                <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Monday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Monday?.Open?.Hour,CurrentStoreData?.CurbsideHours?.Monday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Monday?.Close?.Hour,CurrentStoreData?.CurbsideHours?.Monday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Monday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Tuesday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Tuesday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Tuesday?.Open?.Hour,CurrentStoreData?.CurbsideHours?.Tuesday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Tuesday?.Close?.Hour,CurrentStoreData?.CurbsideHours?.Tuesday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Tuesday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Wednesday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Wednesday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Wednesday?.Open?.Hour,CurrentStoreData?.CurbsideHours?.Wednesday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Wednesday?.Close?.Hour,CurrentStoreData?.CurbsideHours?.Wednesday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Wednesday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Thursday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Thursday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Thursday?.Open?.Hour,CurrentStoreData?.CurbsideHours?.Thursday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Thursday?.Close?.Hour,CurrentStoreData?.CurbsideHours?.Thursday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Thursday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Friday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Friday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Friday?.Open?.Hour,CurrentStoreData?.CurbsideHours?.Friday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Friday?.Close?.Hour,CurrentStoreData?.CurbsideHours?.Friday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Friday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Saturday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Saturday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Saturday?.Open?.Hour,CurrentStoreData?.CurbsideHours?.Saturday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Saturday?.Close?.Hour,CurrentStoreData?.CurbsideHours?.Saturday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Saturday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="box">
                                        <img src="{{storeImage}}" alt="{{selectedStoreName}}" style="border-radius: 0px;margin-bottom: 15px; width: 100%;">

                                        <div style="display: flex;padding: 5px;">
                                            <h3 style="font-size: 16px;">You're shopping at <strong>
                                                    {{selectedStoreName}}</strong></h3>
                                            <div class="newForthis">
                                                <span class="store_open" *ngIf="!StoreClosed">Open</span>
                                                <span class="store_close" *ngIf="StoreClosed">Closed</span>
                                            </div>
                                        </div>
                                        <p class="loc-adddress-home" style="padding: 5px;">
                                            <img src="assets/images/place.png" width="24px" class="loca-img-new">

                                            <a style="font-size: 13px;" href="http://maps.google.com/?q={{storeAddresss}}" target="_blank">
                                                <img style="cursor:pointer;" alt="">{{storeAddresss}}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="manageOrderOption('Pickup')" class="content" id="content1">
                            <div class="row">
                                <div class="col-4"><span>Sunday: </span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Sunday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Sunday?.Open?.Hour,CurrentStoreData?.StoreHours?.Sunday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Sunday?.Close?.Hour,CurrentStoreData?.StoreHours?.Sunday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Sunday?.isOpen">
                                    Closed
                                </div>
                            </div>



                            <div class="row">
                                <div class="col-4"><span>Monday: </span></div>
                                <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Monday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Monday?.Open?.Hour,CurrentStoreData?.StoreHours?.Monday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Monday?.Close?.Hour,CurrentStoreData?.StoreHours?.Monday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Monday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Tuesday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Tuesday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Tuesday?.Open?.Hour,CurrentStoreData?.StoreHours?.Tuesday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Tuesday?.Close?.Hour,CurrentStoreData?.StoreHours?.Tuesday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Tuesday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Wednesday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Wednesday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Wednesday?.Open?.Hour,CurrentStoreData?.StoreHours?.Wednesday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Wednesday?.Close?.Hour,CurrentStoreData?.StoreHours?.Wednesday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Wednesday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Thursday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Thursday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Thursday?.Open?.Hour,CurrentStoreData?.StoreHours?.Thursday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Thursday?.Close?.Hour,CurrentStoreData?.StoreHours?.Thursday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Thursday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Friday:</span></div>


                                <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Friday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Friday?.Open?.Hour,CurrentStoreData?.StoreHours?.Friday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Friday?.Close?.Hour,CurrentStoreData?.StoreHours?.Friday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Friday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4"><span>Saturday:</span></div>

                                <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Saturday?.isOpen">
                                    <span>
                                        <span class="slide_menu_hour">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Saturday?.Open?.Hour,CurrentStoreData?.StoreHours?.Saturday?.Open?.Minute)}}</span>
                                        <span class="slide_menu_dass">-</span>
                                        <span class="slide_menu_min">{{newStoreHoursFormat(CurrentStoreData?.StoreHours?.Saturday?.Close?.Hour,CurrentStoreData?.StoreHours?.Saturday?.Close?.Minute)}}</span>
                                    </span>
                                </div>
                                <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Saturday?.isOpen">
                                    Closed
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="box">
                                        <img src="{{storeImage}}" alt="{{selectedStoreName}}" style="border-radius: 0px;margin-bottom: 15px; width: 100%;">

                                        <div style="display: flex;padding: 5px;">
                                            <h3 style="font-size: 16px;">You're shopping at <strong>
                                                    {{selectedStoreName}}</strong></h3>
                                            <div class="newForthis">
                                                <span class="store_open" *ngIf="!StoreClosed">Open</span>
                                                <span class="store_close" *ngIf="StoreClosed">Closed</span>
                                            </div>
                                        </div>
                                        <p class="loc-adddress-home" style="padding: 5px;">
                                            <img src="assets/images/place.png" width="24px" class="loca-img-new">
                                            <a style="font-size: 13px;" href="http://maps.google.com/?q={{storeAddresss}}" target="_blank">
                                                <img style="cursor:pointer;" alt="">{{storeAddresss}}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="herader_location_popup_close" (click)="closeStoreTimeModal2()"><i class="fa fa-close"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Information Popup-->
<div class=" modal get-verify-number-popup" id="infoPopup" style="background-size: 100%;background: url(assets/images/bg1.jpg);">
    <div class="modal-dialog welcome-to-new-site">
        <div class="modal-content" style="background: transparent; box-shadow: none;">
            <div class="modal-body">
                <div class="get-verify">
                    <!-- <img src="../../../assets/images/logo.png"> -->
                    <a href="javascript:;" style="background: #fff !important;color: #000;font-weight: 700;width: 200px; margin: auto;" (click)="infoPopup(true)" class="get-verified">Ok</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class=" modal get-verify-number-popup" id="worry_address_searchbar" style="background-size: 100%;background: url(assets/images/bg1.jpg) !important;">
    <div class="modal-dialog welcome-to-new-site">
        <div class="modal-content" style="background: transparent; box-shadow: none;">
            <div class="modal-body">
                <div class="get-verify">
                    <h2>Welcome to our new online store </h2>
                    <img src="assets/images/sorry1.png">
                    <h3>We don’t deliver to your area yet </h3>
                    <h4>You can still place an order online for in-store Pickup </h4>
                    <a href="javascript:;" *ngIf="pickUpStoreList?.length > 1" (click)="openModal(0)">SELECT A STORE NEAR YOU</a>
                    <a href="javascript:;" (click)="closePop()">SELECT SAME STORE </a>
                    <a href="javascript:;" (click)="closePop()" class="get-verified close">
                        <img src="assets/images/close1.png" alt="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class=" modal get-verify-number-popup" id="parkvillePopUp" style="background-size: 100%;background: url(ageVerification?.bgImage) !important;">
    <div class="modal-dialog welcome-to-new-site">
        <div class="modal-content" style="background: transparent; box-shadow: none;">
            <div class="modal-body">
                <div class="get-verify">
                    <h2>We are not doing deliveries at this moment.</h2>
                    <h4>You can select Pickup or come visit us at our store</h4>
                    <img src="assets/images/sorry1.png">
                    <a href="javascript:;" *ngIf="pickUpStoreList?.length > 1" (click)="openModal(2)" class="select_store_1">SELECT A STORE NEAR YOU</a>
                    <a href="javascript:;" (click)="closeParkPop()" class="get-verified close">
                        <img src="assets/images/close1.png" alt="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal search-location wrong-loaction-popup" id="cartCheckPopup" style="z-index:9999;" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div>
                    <h5>Replace Cart Item?</h5>
                    <p>Your cart contains item. Do you want to discard the selection and add item from same store.</p>
                </div>
                <button class="transparentButton" id="mailItAlwaysButton" (click)="cartCheckYesFunction()">Yes
                </button>
                <button class="darkButton" (click)="cartCheckNoFunction()">No</button>
            </div>
        </div>
    </div>
</div>

<div class="modal search-location wrong-loaction-popup" id="wrongAddressPopup" style="z-index:9999;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="get-verify" style="margin-bottom:20px;">
                    <img src="assets/images/map.png" class="tickImage" style='width:90px;'>
                </div>
                <div>
                    <h5>Sorry, we are not in your service area for deliveres.</h5>
                </div>
                <button class="darkButton" (click)="closeWrongAddressPopUp()">Change My Address</button>
            </div>
        </div>
    </div>
</div>





<!-- New cart Loader Modal -->
<div class="modal" id="loadMe" tabindex="-1" role="dialog" aria-labelledby="loadMeLabel" data-backdrop="static" data-keyboard="false" style="width: 600px;left:auto; position: absolute;right: 0;z-index: 99999 !important;backdrop-filter: brightness(0.8);">
    <div class="modal-dialog modal-dialog1 modal-sm" role="document">
        <div class="modal-content model-content1" style="box-shadow: none !important;">
            <div class="modal-body text-center" style="position: absolute;top: 45%;left: 50%;transform: translate(-50%, -50%);">
                <!--  <div class="bouncer">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div> -->
                <img src="assets/images/localloader.gif" style="width: 100px;">
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="exampleModal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="background: rgba(0,0,0,0.6); z-index: 99999;">
    <div class="modal-dialog" role="document" style="top: 4%">
        <div class="modal-content" style="padding: 0px;">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Error</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>{{errorMsg}}</p>
            </div>
        </div>
    </div>
</div>
<!--cart limit-->
<div class="modal fade" id="cartLimitModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.6); z-index: 99999;">
    <div class="modal-dialog" role="document" style="top: 20%">
        <div class="modal-content order_limit" [ngStyle]="getColor()">
            <div class="modal-header popup">
                <h5 class="modal-title" id="exampleModalLabel" [ngStyle]="getTextIconColor({'color':siteDada?.headerTextColor},'Powered')">This item puts You,</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fa fa-close"  [ngStyle]="getTextIconColor({'color':siteDada?.headerTextColor},'Powered')"></i>
                </button>
            </div>
            <div class="modal-body">
                <h5 class="content_modal" [ngStyle]="getTextIconColor({'color':siteDada?.headerTextColor},'Powered')">Over The {{CartBarLimit}}g Legal Order Limit</h5>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="cartLimitModalFlower" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.6); z-index: 99999;">
    <div class="modal-dialog" role="document" style="top: 20%">
        <div class="modal-content order_limit" [ngStyle]="getColor()">
            <div class="modal-header popup">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fa fa-close"  [ngStyle]="getTextIconColor({'color':siteDada?.headerTextColor},'Powered')"></i>
                </button>
            </div>
            <div class="modal-body">
                <h4 class="modal-title" id="exampleModalLabel" [ngStyle]="getTextIconColor({'color':siteDada?.headerTextColor},'Powered')">This item puts You,</h4>
                <h5 class="content_modal" [ngStyle]="getTextIconColor({'color':siteDada?.headerTextColor},'Powered')">Over The {{CartBarLimitFlower}}g Legal Order Limit</h5>
            </div>
        </div>
    </div>
</div>


<!-- guest order place error show modal-->
<!--cart limit-->
<div class="modal fade" id="guestOrderErrorModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="background: linear-gradient(rgba(247, 248, 252, 0.7), rgba(232, 233, 247, 0.9)); z-index: 99999;">
    <div class="modal-dialog" role="document" style="top: 20%">
        <div class="modal-content order_limit">
            <div class="modal-header popup">
                <h5 class="modal-title" id="exampleModalLabel"></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fa fa-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <h5 class="content_modal">{{guestOrderPlacingError}}</h5>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="myModal" style="background: rgba(0,0,0,0.8);z-index: 99999;">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
                You are changing your {{modalText}} location from Store {{curretStoreName}} to {{newStoreName}}. All
                Products currently in your cart will be automatically removed.<br><br>
                Are you sure you want to change your {{modalText}} Location?
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary1" (click)="emptyguestcart()">Yes</button>
                <button type="button" class="btn btn-secondary2" (click)="undoDataforStore()">NO</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="limitModal9" style="background: rgba(0,0,0,0.8);z-index: 99999;">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closeModels()" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                Minimum cart limit is {{CompareWithSubTotal | currency:'USD'}}
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="limitModal10" style="background: rgba(0,0,0,0.8);z-index: 99999;">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closeModels()" data-dismiss="modal">&times;</button>
                <div class="modal-body">
                    Minimum cart limit is {{storeAmount | currency:'USD'}}
                </div>

            </div>

        </div>
    </div>
</div>
<div class="modal fade" id="myModal2" style="background: rgba(0,0,0,0.8);z-index: 99999;">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
                You are changing your {{modalText}} location from Store {{curretStoreName}} to {{newStoreName}}. All
                Products currently in your cart will be automatically removed<br><br>
                Are you sure you want to change your {{modalText}} location?
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary1" (click)="clearLogeedInusercart()">Yes</button>
                <button type="button" class="btn btn-secondary2" data-dismiss="modal">NO</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="myModal3" style="background: rgba(0,0,0,0.8);z-index: 99999;">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
                You are changing your {{modalText}} location from Store {{currentstoreHandle}} to {{newStoreHandle}}.
                All Products currently in your cart will be automatically removed.<br><br>
                Are you sure you want to change your {{modalText}} location?
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary1" (click)="geustCartEmptyAddressHandler()">Yes</button>
                <button type="button" class="btn btn-secondary2" data-dismiss="modal">NO</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="myModal4" style="background: rgba(0,0,0,0.8);z-index: 99999;">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body">
                You are changing your {{modalText}} location from Store {{currentstoreHandle}} to {{newStoreHandle}}.
                All Products currently in your cart will be automatically removed.<br><br>
                Are you sure you want to change your {{modalText}} Location?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary1" (click)="loginUserEmptyAddressHandler()">Yes</button>
                <button type="button" class="btn btn-secondary2" data-dismiss="modal">NO</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="myModal5" style="background: rgba(0,0,0,0.8);z-index: 99999;">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body">
                You are changing your Order type from {{getOrderTypeSelected()}}.
                All Products currently in your cart will be automatically removed.<br><br>
                Are you sure you want to change your Order tpye?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary1" (click)="callCartHandlerForOrderTypeChange()">Yes</button>
                <button type="button" class="btn btn-secondary2" data-dismiss="modal">NO</button>
            </div>
        </div>
    </div>
</div>

<div class="modal search-location modalBackgroundNone firstpopuponload where-are-you Pick_Up_Store_new" id="selectStoreModalpop">
    <div class="modal-dialog">

        <div class="modal-content" style='background: transparent!important;'>
            <a style="float:right; font-size: 28px; margin: 20px;color: white;cursor: pointer;" (click)="closeNewStoreList()">
                <i class="fa fa-close" style="float:right;"></i></a>

            <div class="modal-body" style="padding: 0 !important;">


                <div class="Location_checkout">
                    <div class="Checkout_logo">
                        <img src="{{siteDada?.siteLogo}}">

                        <h2>{{siteDada?.storePageTitle}}</h2>
                        <h3>{{siteDada?.storePageDescription}}</h3>
                    </div>
                    <div class="All-Location_List">
                        <div class="row">
                            <ng-container *ngFor=" let list of pickUpStoreList;let k=index">
                                <div class="col-md-4">
                                    <div class="Location_list">
                                        <h4>
                                            {{list?.Name}}
                                            <a href="javascript:;" (click)="storeOpenCloseTimeingnew(list?.Name,list)">
                                                <img src="assets/images/about-icon-23.png">
                                            </a>
                                        </h4>
                                        <figure>
                                            <img src="{{list?.image}}" class="location-store-img" (click)="updatePickUpStoreData(list?.Id, list?.Name,  list?.storeAccountNum, list?.authorization,  list.Address.AddressLine1, list.Address.AddressLine2, list.Address.City, list.Address.StateName, list.Address.StateCode, list.Address.CountryName, list.Address.CountryCode, list.Address.Zip, list?.storeLocation, list?.coordinates[0], list?.coordinates[1],true,'true','true')">
                                        </figure>
                                        <a href="javascript:;" (click)="updatePickUpStoreData(list?.Id, list?.Name, list?.storeAccountNum, list?.authorization, list.Address.AddressLine1, list.Address.AddressLine2, list.Address.City, list.Address.StateName, list.Address.StateCode, list.Address.CountryName, list.Address.CountryCode, list.Address.Zip, list?.storeLocation, list?.coordinates[0], list?.coordinates[1],true,'true','true')" class="Site_product_list">menu</a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <div id="popup1information" class="overlay1information">
        <div class="popup1information">
            <a class="close" href="#">&times;</a>
            <div class="content_pop">
                <p>Delivery Available!</p>
                <p><b>Please read details below before ordering.</b></p>
                <p>Important Details for Delivery</p>
                <p><b>Cut-Off for Same Day Delivery: 3:00pm</b></p>
                <p><b>Delivery Window: 3:00pm to 5:00pm</b></p>
                <p>When your Delivery Driver has left the store with your order, you will receive a text message
                    confirming they are on the way. The delivery will <b>arrive between 3:00pm and 5:00pm.</b></p>
                <p>Please meet your delivery driver at the front door of provided address with your ID. All deliveries
                    must be signed for by an individual 19 years of age or older.</p>
                <p>If there are any specific instructions or steps needed for your driver to get to your front door,
                    please provide in the "Special Instructions" section when completing your order. </p>
                <p><b>DELIVERY IS ONLY AVAILABLE FOR PRE-PAID ORDERS AT CHECKOUT.</b></p>
                <p>Proudly serving the Parksville, French Creek, Errington, Coombs, Qualicum, Nanoose Bay and Lantzville
                    regions.</p>
                <p>Delivery Minimums:</p>
                <p>Parksville/French Creek ($25)</p>
                <p>Nanoose Bay/Qualicum Beach/Coombs/Errington ($50)</p>
                <p>Lantzville ($100)</p>
                <p>Delivery Fees</p>
                <p> $0 for orders of $75 or greater</p>
                <p>$5 for orders less than $75</p>
                <p>All Sales are Final. No Refunds unless provincially recalled Delivery Available Now! Please read
                    details below before ordering. </p>
            </div>
        </div>
    </div>
</div>
<div class="modal fade modal get-verify-number-popup" id="storeInfo" style="background: rgba(241, 237, 237, 0.8);z-index: 99999;">
    <div class="modal-dialog modal-sm">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="herader_location_overlay">
                        <div class="herader_location_popup">
                            <a *ngIf="pickUpStoreList?.length > 1" (click)="selectMailOrderFromHeader('true')" class="newButton" style="display: inline-block;">
                                Switch Location

                            </a>
                            <!-- <img src="{{selectedStoreImage}}" alt="{{selectedStoreName}}" style="border-radius: 0px;margin-bottom: 15px; height: 200px;width: 100%;"> -->
                            <div>
                                <h2>{{selectedStoreName}}
                                    <span class="store_open" *ngIf="!StoreClosed">Open</span>
                                    <span class="store_close" *ngIf="StoreClosed">Closed</span>
                                </h2>
                            </div>
                            <p class="loc-adddress-home">
                                <img src="assets/images/place.png" width="24px" class="loca-img-new">
                                <a href="http://maps.google.com/?q={{storeAddress?.AddressLine1}}" target="_blank"> <img style="cursor:pointer;" alt="">{{storeAddress?.AddressLine1}}
                                </a>
                            </p>


                            <p style="font-size: 16px " id="newIdgivenNow">{{manageOrderOptions('Delivery')}}{{manageOrderOptions('Pickup')}}{{manageOrderOptions('CurbsidePickup')}}<br>
                                <b style="font-size: 13px ;" class="stylePop">
                                    <!-- MON - SAT 9AM - 8:45PM SUNDAY 10AM - 6:45PM -->
                                    In-Store
                                    {{newStoreHoursFormat(this.storeTime?.Open?.Hour,this.storeTime?.Open?.Minute)}} -
                                    {{newStoreHoursFormat(this.storeTime?.Close?.Hour,this.storeTime?.Close?.Minute)}}
                                    <br>
                                    Delivery
                                    {{newStoreHoursFormat(this.dilverytime?.Open?.Hour,this.dilverytime?.Open?.Minute)}}
                                    -
                                    {{newStoreHoursFormat(this.dilverytime?.Close?.Hour,this.dilverytime?.Close?.Minute)}}
                                </b>
                            </p>

                            <div class="mobile-visible">
                                <div class="row">
                                    <h4 style="padding: 3px 0px 0px 10px;"> Service Options </h4>
                                    <a style="margin-left: 10px;" (click)="storeOpenCloseTimeing(CurrentStoreData?.Name)">
                                        <img src="assets/images/about-icon-23.png" width="24px"></a>
                                    <a class="call-me" style="cursor: pointer;margin-top: -3px;margin-left: 5px;" [href]="'tel:'+getStoreMObile()"><i style="font-size: 24px;" class="fa fa-phone"></i></a>
                                </div>
                                <div style="height:40px;">&nbsp;</div>
                                <div class="herader_location_overlay">
                                    <div class="mobileViewMenu">
                                        <a class="mobileView" href="#" (click)="landOnDashboeard()">View
                                            Menu</a>
                                    </div>
                                </div>
                            </div>
                            <a class="herader_location_popup_close" (click)="modalClosestoreInfo()"><i class="fa fa-close"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>